import { ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, ɵsetClassMetadata, NgModule, ɵɵdefineComponent, ɵɵelement, ɵɵproperty, Component, Input, ɵɵdefineInjectable, Injectable, InjectionToken, ɵɵinject, Inject, ɵɵelementContainer, ɵɵnextContext, ɵɵpureFunction1, ɵɵgetCurrentView, ɵɵelementStart, ɵɵlistener, ɵɵrestoreView, ɵɵnamespaceSVG, ɵɵelementEnd, ɵɵtext, ɵɵtemplate, ɵɵadvance, ɵɵtextInterpolate, EventEmitter, ɵɵdirectiveInject, ElementRef, Renderer2, ɵɵProvidersFeature, ɵɵtemplateRefExtractor, ɵɵreference, ChangeDetectionStrategy, Output, ChangeDetectorRef, ViewContainerRef, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ViewChild, ɵɵclassMapInterpolate2, ɵɵsanitizeHtml, ɵɵNgOnChangesFeature, ɵɵclassMapInterpolate1, ɵɵpropertyInterpolate, ɵɵtextInterpolate1, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵInheritDefinitionFeature, ViewEncapsulation, ɵɵpureFunction2, ɵɵstyleProp, ɵɵpureFunction0, ɵɵpropertyInterpolate1, ɵɵsanitizeUrl, Optional, SkipSelf } from '@angular/core';
import { NgClass, NgIf, NgTemplateOutlet, NgForOf, CommonModule } from '@angular/common';
import { FormBuilder, FormsModule, ReactiveFormsModule, NgControlStatus, NgModel, Validators, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, FormControlName, RequiredValidator, NgSelectOption, ɵangular_packages_forms_forms_x } from '@angular/forms';
import { DragDropModule, CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule, MatButton } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule, MatCheckbox } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule, MatOption } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogActions, MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatInputModule, MatInput } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule, MatProgressBar } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule, MatTooltip } from '@angular/material/tooltip';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BaseUICommonModule } from 'baseuicommon';
import { Subject, fromEvent, throwError, of, Observable } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take, first, tap, map, catchError } from 'rxjs/operators';
import { Overlay } from '@angular/cdk/overlay';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
import { Alert, AlertType, ErrorBase, ErrorServer, NotificationType, MessageError, AppInjector } from 'base-models';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { BAD_REQUEST, FORBIDDEN, UNAUTHORIZED } from 'http-status-codes';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Md5 } from 'ts-md5/dist/md5';
import { AUTH_SERVICE_PROVIDER_TOKEN, AuthenticationServiceAbs } from 'baseauth';
import { get } from 'lodash';

const materialModules = [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    ScrollingModule
];
class MaterialModule {
}
MaterialModule.ɵmod = ɵɵdefineNgModule({ type: MaterialModule });
MaterialModule.ɵinj = ɵɵdefineInjector({ factory: function MaterialModule_Factory(t) { return new (t || MaterialModule)(); }, providers: [], imports: [[
            materialModules,
            DragDropModule
        ], MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        ScrollingModule, DragDropModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(MaterialModule, { imports: [MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        ScrollingModule, DragDropModule], exports: [MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        ScrollingModule, DragDropModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(MaterialModule, [{
        type: NgModule,
        args: [{
                imports: [
                    materialModules,
                    DragDropModule
                ],
                exports: [
                    materialModules,
                    DragDropModule
                ],
                entryComponents: [],
                declarations: [],
                providers: [],
            }]
    }], null, null); })();

class FlagIconComponent {
    constructor() { }
    ngOnInit() {
        this.squared = (this.squared != undefined);
    }
    addingFlagClasses() {
        return `flag-icon flag-icon-${this.country} ${this.squared ? 'flag-icon-squared' : ''}`;
    }
}
FlagIconComponent.ɵfac = function FlagIconComponent_Factory(t) { return new (t || FlagIconComponent)(); };
FlagIconComponent.ɵcmp = ɵɵdefineComponent({ type: FlagIconComponent, selectors: [["frms-flag-icon"]], inputs: { country: "country", squared: "squared" }, decls: 1, vars: 1, consts: [[3, "ngClass"]], template: function FlagIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "span", 0);
    } if (rf & 2) {
        ɵɵproperty("ngClass", ctx.addingFlagClasses());
    } }, directives: [NgClass], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FlagIconComponent, [{
        type: Component,
        args: [{
                selector: 'frms-flag-icon',
                template: `
    <span [ngClass]="addingFlagClasses()"></span>
  `,
                styles: []
            }]
    }], function () { return []; }, { country: [{
            type: Input
        }], squared: [{
            type: Input
        }] }); })();

/**
 * Notification
 *
 * This class describes the structure of a notifiction, including all information it needs to live, and everyone else needs to work with it.
 */
class NotifierNotification {
    /**
     * Constructor
     *
     * @param options Notifier options
     */
    constructor(options) {
        /**
         * The template to customize
         * the appearance of the notification
         */
        this.template = null;
        Object.assign(this, options);
        // If not set manually, we have to create a unique notification ID by ourselves. The ID generation relies on the current browser
        // datetime in ms, in praticular the moment this notification gets constructed. Concurrency, and thus two IDs being the exact same,
        // is not possible due to the action queue concept.
        if (options.id === undefined) {
            this.id = `ID_${new Date().getTime()}`;
        }
    }
}

/**
 * Notifier queue service
 *
 * In general, API calls don't get processed right away. Instead, we have to queue them up in order to prevent simultanious API calls
 * interfering with each other. This, at least in theory, is possible at any time. In particular, animations - which potentially overlap -
 * can cause changes in JS classes as well as affect the DOM. Therefore, the queue service takes all actions, puts them in a queue, and
 * processes them at the right time (which is when the previous action has been processed successfully).
 *
 * Technical sidenote:
 * An action looks pretty similar to the ones within the Flux / Redux pattern.
 */
class NotifierQueueService {
    /**
     * Constructor
     */
    constructor() {
        this.actionStream = new Subject();
        this.actionQueue = [];
        this.isActionInProgress = false;
    }
    /**
     * Push a new action to the queue, and try to run it
     *
     * @param action Action object
     */
    push(action) {
        this.actionQueue.push(action);
        this.tryToRunNextAction();
    }
    /**
     * Continue with the next action (called when the current action is finished)
     */
    continue() {
        this.isActionInProgress = false;
        this.tryToRunNextAction();
    }
    /**
     * Try to run the next action in the queue; we skip if there already is some action in progress, or if there is no action left
     */
    tryToRunNextAction() {
        if (this.isActionInProgress || this.actionQueue.length === 0) {
            return; // Skip (the queue can now go drink a coffee as it has nothing to do anymore)
        }
        this.isActionInProgress = true;
        this.actionStream.next(this.actionQueue.shift()); // Push next action to the stream, and remove the current action from the queue
    }
}
NotifierQueueService.ɵfac = function NotifierQueueService_Factory(t) { return new (t || NotifierQueueService)(); };
NotifierQueueService.ɵprov = ɵɵdefineInjectable({ token: NotifierQueueService, factory: NotifierQueueService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotifierQueueService, [{
        type: Injectable
    }], function () { return []; }, null); })();

// tslint:disable variable-name
/**
 * Injection Token for notifier options
 */
const NotifierOptionsToken = new InjectionToken('[angular-notifier] Notifier Options');
/**
 * Injection Token for notifier configuration
 */
const NotifierConfigToken = new InjectionToken('[anuglar-notifier] Notifier Config');
// tslint:enable variable-name

/**
 * Notifier configuration
 *
 * The notifier configuration defines what notifications look like, how they behave, and how they get animated. It is a global
 * configuration, which means that it only can be set once (at the beginning), and cannot be changed afterwards. Aligning to the world of
 * Angular, this configuration can be provided in the root app module - alternatively, a meaningful default configuration will be used.
 */
class NotifierConfig {
    /**
     * Constructor
     *
     * @param [customOptions={}] Custom notifier options, optional
     */
    constructor(customOptions = {}) {
        // Set default values
        this.animations = {
            enabled: true,
            hide: {
                easing: 'ease',
                offset: 50,
                preset: 'fade',
                speed: 300
            },
            overlap: 150,
            shift: {
                easing: 'ease',
                speed: 300
            },
            show: {
                easing: 'ease',
                preset: 'slide',
                speed: 300
            }
        };
        this.behaviour = {
            autoHide: 7000,
            onClick: false,
            onMouseover: 'pauseAutoHide',
            showDismissButton: true,
            stacking: 4
        };
        this.position = {
            horizontal: {
                distance: 12,
                position: 'left'
            },
            vertical: {
                distance: 12,
                gap: 10,
                position: 'bottom'
            }
        };
        this.theme = 'material';
        // The following merges the custom options into the notifier config, respecting the already set default values
        // This linear, more explicit and code-sizy workflow is preferred here over a recursive one (because we know the object structure)
        // Technical sidenote: Objects are merged, other types of values simply overwritten / copied
        if (customOptions.theme !== undefined) {
            this.theme = customOptions.theme;
        }
        if (customOptions.animations !== undefined) {
            if (customOptions.animations.enabled !== undefined) {
                this.animations.enabled = customOptions.animations.enabled;
            }
            if (customOptions.animations.overlap !== undefined) {
                this.animations.overlap = customOptions.animations.overlap;
            }
            if (customOptions.animations.hide !== undefined) {
                Object.assign(this.animations.hide, customOptions.animations.hide);
            }
            if (customOptions.animations.shift !== undefined) {
                Object.assign(this.animations.shift, customOptions.animations.shift);
            }
            if (customOptions.animations.show !== undefined) {
                Object.assign(this.animations.show, customOptions.animations.show);
            }
        }
        if (customOptions.behaviour !== undefined) {
            Object.assign(this.behaviour, customOptions.behaviour);
        }
        if (customOptions.position !== undefined) {
            if (customOptions.position.horizontal !== undefined) {
                Object.assign(this.position.horizontal, customOptions.position.horizontal);
            }
            if (customOptions.position.vertical !== undefined) {
                Object.assign(this.position.vertical, customOptions.position.vertical);
            }
        }
    }
}

/**
 * Notifier service
 *
 * This service provides access to the public notifier API. Once injected into a component, directive, pipe, service, or any other building
 * block of an applications, it can be used to show new notifications, and hide existing ones. Internally, it transforms API calls into
 * actions, which then get thrown into the action queue - eventually being processed at the right moment.
 */
class NotifierService {
    /**
     * Constructor
     *
     * @param notifierQueueService Notifier queue service
     * @param config               Notifier configuration, optionally injected as a dependency
     */
    constructor(notifierQueueService, config) {
        this.queueService = notifierQueueService;
        this.config = config;
    }
    /**
     * Get the notifier configuration
     *
     * @returns Notifier configuration
     */
    getConfig() {
        return this.config;
    }
    /**
     * API: Show a new notification
     *
     * @param notificationOptions Notification options
     */
    show(notificationOptions) {
        this.queueService.push({
            payload: notificationOptions,
            type: 'SHOW'
        });
    }
    /**
     * API: Hide a specific notification, given its ID
     *
     * @param notificationId ID of the notification to hide
     */
    hide(notificationId) {
        this.queueService.push({
            payload: notificationId,
            type: 'HIDE'
        });
    }
    /**
     * API: Hide the newest notification
     */
    hideNewest() {
        this.queueService.push({
            type: 'HIDE_NEWEST'
        });
    }
    /**
     * API: Hide the oldest notification
     */
    hideOldest() {
        this.queueService.push({
            type: 'HIDE_OLDEST'
        });
    }
    /**
     * API: Hide all notifications at once
     */
    hideAll() {
        this.queueService.push({
            type: 'HIDE_ALL'
        });
    }
    /**
     * API: Shortcut for showing a new notification
     *
     * @param type             Type of the notification
     * @param message          Message of the notification
     * @param [notificationId] Unique ID for the notification (optional)
     */
    notify(type, message, notificationId) {
        let notificationOptions = {
            message,
            type
        };
        if (notificationId !== undefined) {
            notificationOptions.id = notificationId;
        }
        this.show(notificationOptions);
    }
}
NotifierService.ɵfac = function NotifierService_Factory(t) { return new (t || NotifierService)(ɵɵinject(NotifierQueueService), ɵɵinject(NotifierConfigToken)); };
NotifierService.ɵprov = ɵɵdefineInjectable({ token: NotifierService, factory: NotifierService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotifierService, [{
        type: Injectable
    }], function () { return [{ type: NotifierQueueService }, { type: NotifierConfig, decorators: [{
                type: Inject,
                args: [NotifierConfigToken]
            }] }]; }, null); })();

/**
 * Notifier timer service
 *
 * This service acts as a timer, needed due to the still rather limited setTimeout JavaScript API. The timer service can start and stop a
 * timer. Furthermore, it can also pause the timer at any time, and resume later on. The timer API workd promise-based.
 */
class NotifierTimerService {
    /**
     * Constructor
     */
    constructor() {
        this.now = 0;
        this.remaining = 0;
    }
    /**
     * Start (or resume) the timer
     *
     * @param   duration Timer duration, in ms
     * @returns          Promise, resolved once the timer finishes
     */
    start(duration) {
        return new Promise((resolve, reject) => {
            // For the first run ...
            this.remaining = duration;
            // Setup, then start the timer
            this.finishPromiseResolver = resolve;
            this.continue();
        });
    }
    /**
     * Pause the timer
     */
    pause() {
        clearTimeout(this.timerId);
        this.remaining -= new Date().getTime() - this.now;
    }
    /**
     * Continue the timer
     */
    continue() {
        this.now = new Date().getTime();
        this.timerId = window.setTimeout(() => {
            this.finish();
        }, this.remaining);
    }
    /**
     * Stop the timer
     */
    stop() {
        clearTimeout(this.timerId);
        this.remaining = 0;
    }
    /**
     * Finish up the timeout by resolving the timer promise
     */
    finish() {
        this.finishPromiseResolver();
    }
}
NotifierTimerService.ɵfac = function NotifierTimerService_Factory(t) { return new (t || NotifierTimerService)(); };
NotifierTimerService.ɵprov = ɵɵdefineInjectable({ token: NotifierTimerService, factory: NotifierTimerService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotifierTimerService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Fade animation preset
 */
const fade = {
    hide: () => {
        return {
            from: {
                opacity: '1'
            },
            to: {
                opacity: '0'
            }
        };
    },
    show: () => {
        return {
            from: {
                opacity: '0'
            },
            to: {
                opacity: '1'
            }
        };
    }
};

/**
 * Slide animation preset
 */
const slide = {
    hide: (notification) => {
        // Prepare variables
        const config = notification.component.getConfig();
        const shift = notification.component.getShift();
        let from;
        let to;
        // Configure variables, depending on configuration and component
        if (config.position.horizontal.position === 'left') {
            from = {
                transform: `translate3d( 0, ${shift}px, 0 )`
            };
            to = {
                transform: `translate3d( calc( -100% - ${config.position.horizontal.distance}px - 10px ), ${shift}px, 0 )`
            };
        }
        else if (config.position.horizontal.position === 'right') {
            from = {
                transform: `translate3d( 0, ${shift}px, 0 )`
            };
            to = {
                transform: `translate3d( calc( 100% + ${config.position.horizontal.distance}px + 10px ), ${shift}px, 0 )`
            };
        }
        else {
            let horizontalPosition;
            if (config.position.vertical.position === 'top') {
                horizontalPosition = `calc( -100% - ${config.position.horizontal.distance}px - 10px )`;
            }
            else {
                horizontalPosition = `calc( 100% + ${config.position.horizontal.distance}px + 10px )`;
            }
            from = {
                transform: `translate3d( -50%, ${shift}px, 0 )`
            };
            to = {
                transform: `translate3d( -50%, ${horizontalPosition}, 0 )`
            };
        }
        // Done
        return {
            from,
            to
        };
    },
    show: (notification) => {
        // Prepare variables
        const config = notification.component.getConfig();
        let from;
        let to;
        // Configure variables, depending on configuration and component
        if (config.position.horizontal.position === 'left') {
            from = {
                transform: `translate3d( calc( -100% - ${config.position.horizontal.distance}px - 10px ), 0, 0 )`
            };
            to = {
                transform: 'translate3d( 0, 0, 0 )'
            };
        }
        else if (config.position.horizontal.position === 'right') {
            from = {
                transform: `translate3d( calc( 100% + ${config.position.horizontal.distance}px + 10px ), 0, 0 )`
            };
            to = {
                transform: 'translate3d( 0, 0, 0 )'
            };
        }
        else {
            let horizontalPosition;
            if (config.position.vertical.position === 'top') {
                horizontalPosition = `calc( -100% - ${config.position.horizontal.distance}px - 10px )`;
            }
            else {
                horizontalPosition = `calc( 100% + ${config.position.horizontal.distance}px + 10px )`;
            }
            from = {
                transform: `translate3d( -50%, ${horizontalPosition}, 0 )`
            };
            to = {
                transform: 'translate3d( -50%, 0, 0 )'
            };
        }
        // Done
        return {
            from,
            to
        };
    }
};

/**
 * Notifier animation service
 */
class NotifierAnimationService {
    /**
     * Constructor
     */
    constructor() {
        this.animationPresets = {
            fade,
            slide
        };
    }
    /**
     * Get animation data
     *
     * This method generates all data the Web Animations API needs to animate our notification. The result depends on both the animation
     * direction (either in or out) as well as the notifications (and its attributes) itself.
     *
     * @param   direction    Animation direction, either in or out
     * @param   notification Notification the animation data should be generated for
     * @returns Animation information
     */
    getAnimationData(direction, notification) {
        // Get all necessary animation data
        let keyframes;
        let duration;
        let easing;
        if (direction === 'show') {
            keyframes = this.animationPresets[notification.component.getConfig().animations.show.preset].show(notification);
            duration = notification.component.getConfig().animations.show.speed;
            easing = notification.component.getConfig().animations.show.easing;
        }
        else {
            keyframes = this.animationPresets[notification.component.getConfig().animations.hide.preset].hide(notification);
            duration = notification.component.getConfig().animations.hide.speed;
            easing = notification.component.getConfig().animations.hide.easing;
        }
        // Build and return animation data
        return {
            keyframes: [
                keyframes.from,
                keyframes.to
            ],
            options: {
                duration,
                easing,
                fill: 'forwards' // Keep the newly painted state after the animation finished
            }
        };
    }
}
NotifierAnimationService.ɵfac = function NotifierAnimationService_Factory(t) { return new (t || NotifierAnimationService)(); };
NotifierAnimationService.ɵprov = ɵɵdefineInjectable({ token: NotifierAnimationService, factory: NotifierAnimationService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotifierAnimationService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const _c0 = function (a0) { return { notification: a0 }; };
function NotifierNotificationComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0, 2);
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("ngTemplateOutlet", ctx_r0.notification.template)("ngTemplateOutletContext", ɵɵpureFunction1(2, _c0, ctx_r0.notification));
} }
function NotifierNotificationComponent_ng_template_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 5);
    ɵɵlistener("click", function NotifierNotificationComponent_ng_template_1_button_2_Template_button_click_0_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(2); return ctx_r4.onClickDismiss(); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", 6);
    ɵɵelement(2, "path", 7);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function NotifierNotificationComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 3);
    ɵɵtext(1);
    ɵɵelementEnd();
    ɵɵtemplate(2, NotifierNotificationComponent_ng_template_1_button_2_Template, 3, 0, "button", 4);
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r2.notification.message);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.config.behaviour.showDismissButton);
} }
/**
 * Notifier notification component
 * -------------------------------
 * This component is responsible for actually displaying the notification on screen. In addition, it's able to show and hide this
 * notification, in particular to animate this notification in and out, as well as shift (move) this notification vertically around.
 * Furthermore, the notification component handles all interactions the user has with this notification / component, such as clicks and
 * mouse movements.
 */
class NotifierNotificationComponent {
    /**
     * Constructor
     *
     * @param elementRef               Reference to the component's element
     * @param renderer                 Angular renderer
     * @param notifierService          Notifier service
     * @param notifierTimerService     Notifier timer service
     * @param notifierAnimationService Notifier animation service
     */
    constructor(elementRef, renderer, notifierService, notifierTimerService, notifierAnimationService) {
        this.config = notifierService.getConfig();
        this.ready = new EventEmitter();
        this.dismiss = new EventEmitter();
        this.timerService = notifierTimerService;
        this.animationService = notifierAnimationService;
        this.renderer = renderer;
        this.element = elementRef.nativeElement;
        this.elementShift = 0;
    }
    /**
     * Component after view init lifecycle hook, setts up the component and then emits the ready event
     */
    ngAfterViewInit() {
        this.setup();
        this.elementHeight = this.element.offsetHeight;
        this.elementWidth = this.element.offsetWidth;
        this.ready.emit(this);
    }
    /**
     * Get the notifier config
     *
     * @returns Notifier configuration
     */
    getConfig() {
        return this.config;
    }
    /**
     * Get notification element height (in px)
     *
     * @returns Notification element height (in px)
     */
    getHeight() {
        return this.elementHeight;
    }
    /**
     * Get notification element width (in px)
     *
     * @returns Notification element height (in px)
     */
    getWidth() {
        return this.elementWidth;
    }
    /**
     * Get notification shift offset (in px)
     *
     * @returns Notification element shift offset (in px)
     */
    getShift() {
        return this.elementShift;
    }
    /**
     * Show (animate in) this notification
     *
     * @returns Promise, resolved when done
     */
    show() {
        return new Promise((resolve, reject) => {
            // Are animations enabled?
            if (this.config.animations.enabled && this.config.animations.show.speed > 0) {
                // Get animation data
                const animationData = this.animationService.getAnimationData('show', this.notification);
                // Set initial styles (styles before animation), prevents quick flicker when animation starts
                const animatedProperties = Object.keys(animationData.keyframes[0]);
                for (let i = animatedProperties.length - 1; i >= 0; i--) {
                    this.renderer.setStyle(this.element, animatedProperties[i], animationData.keyframes[0][animatedProperties[i]]);
                }
                // Animate notification in
                this.renderer.setStyle(this.element, 'visibility', 'visible');
                const animation = this.element.animate(animationData.keyframes, animationData.options);
                animation.onfinish = () => {
                    this.startAutoHideTimer();
                    resolve(); // Done
                };
            }
            else {
                // Show notification
                this.renderer.setStyle(this.element, 'visibility', 'visible');
                this.startAutoHideTimer();
                resolve(); // Done
            }
        });
    }
    /**
     * Hide (animate out) this notification
     *
     * @returns Promise, resolved when done
     */
    hide() {
        return new Promise((resolve, reject) => {
            this.stopAutoHideTimer();
            // Are animations enabled?
            if (this.config.animations.enabled && this.config.animations.hide.speed > 0) {
                const animationData = this.animationService.getAnimationData('hide', this.notification);
                const animation = this.element.animate(animationData.keyframes, animationData.options);
                animation.onfinish = () => {
                    resolve(); // Done
                };
            }
            else {
                resolve(); // Done
            }
        });
    }
    /**
     * Shift (move) this notification
     *
     * @param   distance         Distance to shift (in px)
     * @param   shiftToMakePlace Flag, defining in which direction to shift
     * @returns Promise, resolved when done
     */
    shift(distance, shiftToMakePlace) {
        return new Promise((resolve, reject) => {
            // Calculate new position (position after the shift)
            let newElementShift;
            if ((this.config.position.vertical.position === 'top' && shiftToMakePlace)
                || (this.config.position.vertical.position === 'bottom' && !shiftToMakePlace)) {
                newElementShift = this.elementShift + distance + this.config.position.vertical.gap;
            }
            else {
                newElementShift = this.elementShift - distance - this.config.position.vertical.gap;
            }
            const horizontalPosition = this.config.position.horizontal.position === 'middle' ? '-50%' : '0';
            // Are animations enabled?
            if (this.config.animations.enabled && this.config.animations.shift.speed > 0) {
                const animationData = {
                    keyframes: [
                        {
                            transform: `translate3d( ${horizontalPosition}, ${this.elementShift}px, 0 )`
                        },
                        {
                            transform: `translate3d( ${horizontalPosition}, ${newElementShift}px, 0 )`
                        }
                    ],
                    options: {
                        duration: this.config.animations.shift.speed,
                        easing: this.config.animations.shift.easing,
                        fill: 'forwards'
                    }
                };
                this.elementShift = newElementShift;
                const animation = this.element.animate(animationData.keyframes, animationData.options);
                animation.onfinish = () => {
                    resolve(); // Done
                };
            }
            else {
                this.renderer.setStyle(this.element, 'transform', `translate3d( ${horizontalPosition}, ${newElementShift}px, 0 )`);
                this.elementShift = newElementShift;
                resolve(); // Done
            }
        });
    }
    /**
     * Handle click on dismiss button
     */
    onClickDismiss() {
        this.dismiss.emit(this.notification.id);
    }
    /**
     * Handle mouseover over notification area
     */
    onNotificationMouseover() {
        if (this.config.behaviour.onMouseover === 'pauseAutoHide') {
            this.pauseAutoHideTimer();
        }
        else if (this.config.behaviour.onMouseover === 'resetAutoHide') {
            this.stopAutoHideTimer();
        }
    }
    /**
     * Handle mouseout from notification area
     */
    onNotificationMouseout() {
        if (this.config.behaviour.onMouseover === 'pauseAutoHide') {
            this.continueAutoHideTimer();
        }
        else if (this.config.behaviour.onMouseover === 'resetAutoHide') {
            this.startAutoHideTimer();
        }
    }
    /**
     * Handle click on notification area
     */
    onNotificationClick() {
        if (this.config.behaviour.onClick === 'hide') {
            this.onClickDismiss();
        }
    }
    /**
     * Start the auto hide timer (if enabled)
     */
    startAutoHideTimer() {
        if (this.config.behaviour.autoHide !== false && this.config.behaviour.autoHide > 0) {
            this.timerService.start(this.config.behaviour.autoHide).then(() => {
                this.onClickDismiss();
            });
        }
    }
    /**
     * Pause the auto hide timer (if enabled)
     */
    pauseAutoHideTimer() {
        if (this.config.behaviour.autoHide !== false && this.config.behaviour.autoHide > 0) {
            this.timerService.pause();
        }
    }
    /**
     * Continue the auto hide timer (if enabled)
     */
    continueAutoHideTimer() {
        if (this.config.behaviour.autoHide !== false && this.config.behaviour.autoHide > 0) {
            this.timerService.continue();
        }
    }
    /**
     * Stop the auto hide timer (if enabled)
     */
    stopAutoHideTimer() {
        if (this.config.behaviour.autoHide !== false && this.config.behaviour.autoHide > 0) {
            this.timerService.stop();
        }
    }
    /**
     * Initial notification setup
     */
    setup() {
        // Set start position (initially the exact same for every new notification)
        if (this.config.position.horizontal.position === 'left') {
            this.renderer.setStyle(this.element, 'left', `${this.config.position.horizontal.distance}px`);
        }
        else if (this.config.position.horizontal.position === 'right') {
            this.renderer.setStyle(this.element, 'right', `${this.config.position.horizontal.distance}px`);
        }
        else {
            this.renderer.setStyle(this.element, 'left', '50%');
            // Let's get the GPU handle some work as well (#perfmatters)
            this.renderer.setStyle(this.element, 'transform', 'translate3d( -50%, 0, 0 )');
        }
        if (this.config.position.vertical.position === 'top') {
            this.renderer.setStyle(this.element, 'top', `${this.config.position.vertical.distance}px`);
        }
        else {
            this.renderer.setStyle(this.element, 'bottom', `${this.config.position.vertical.distance}px`);
        }
        // Add classes (responsible for visual design)
        this.renderer.addClass(this.element, `notifier__notification--${this.notification.type}`);
        this.renderer.addClass(this.element, `notifier__notification--${this.config.theme}`);
    }
}
NotifierNotificationComponent.ɵfac = function NotifierNotificationComponent_Factory(t) { return new (t || NotifierNotificationComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(Renderer2), ɵɵdirectiveInject(NotifierService), ɵɵdirectiveInject(NotifierTimerService), ɵɵdirectiveInject(NotifierAnimationService)); };
NotifierNotificationComponent.ɵcmp = ɵɵdefineComponent({ type: NotifierNotificationComponent, selectors: [["notifier-notification"]], hostAttrs: [1, "notifier__notification"], hostBindings: function NotifierNotificationComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("click", function NotifierNotificationComponent_click_HostBindingHandler() { return ctx.onNotificationClick(); })("mouseout", function NotifierNotificationComponent_mouseout_HostBindingHandler() { return ctx.onNotificationMouseout(); })("mouseover", function NotifierNotificationComponent_mouseover_HostBindingHandler() { return ctx.onNotificationMouseover(); });
    } }, inputs: { notification: "notification" }, outputs: { ready: "ready", dismiss: "dismiss" }, features: [ɵɵProvidersFeature([
            // We provide the timer to the component's local injector, so that every notification components gets its own
            // instance of the timer service, thus running their timers independently from each other
            NotifierTimerService
        ])], decls: 3, vars: 2, consts: [[3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], ["predefinedNotification", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "notifier__notification-message"], ["class", "notifier__notification-button", "type", "button", "title", "dismiss", 3, "click", 4, "ngIf"], ["type", "button", "title", "dismiss", 1, "notifier__notification-button", 3, "click"], ["viewBox", "0 0 24 24", "width", "20", "height", "20", 1, "notifier__notification-button-icon"], ["d", "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"]], template: function NotifierNotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, NotifierNotificationComponent_ng_container_0_Template, 1, 4, "ng-container", 0);
        ɵɵtemplate(1, NotifierNotificationComponent_ng_template_1_Template, 3, 2, "ng-template", null, 1, ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵɵreference(2);
        ɵɵproperty("ngIf", ctx.notification.template)("ngIfElse", _r1);
    } }, directives: [NgIf, NgTemplateOutlet], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotifierNotificationComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    '(click)': 'onNotificationClick()',
                    '(mouseout)': 'onNotificationMouseout()',
                    '(mouseover)': 'onNotificationMouseover()',
                    class: 'notifier__notification'
                },
                providers: [
                    // We provide the timer to the component's local injector, so that every notification components gets its own
                    // instance of the timer service, thus running their timers independently from each other
                    NotifierTimerService
                ],
                selector: 'notifier-notification',
                templateUrl: './notifier-notification.component.html'
            }]
    }], function () { return [{ type: ElementRef }, { type: Renderer2 }, { type: NotifierService }, { type: NotifierTimerService }, { type: NotifierAnimationService }]; }, { notification: [{
            type: Input
        }], ready: [{
            type: Output
        }], dismiss: [{
            type: Output
        }] }); })();

function NotifierContainerComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", 1);
    ɵɵelementStart(1, "notifier-notification", 2);
    ɵɵlistener("ready", function NotifierContainerComponent_li_1_Template_notifier_notification_ready_1_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.onNotificationReady($event); })("dismiss", function NotifierContainerComponent_li_1_Template_notifier_notification_dismiss_1_listener($event) { ɵɵrestoreView(_r3); const ctx_r4 = ɵɵnextContext(); return ctx_r4.onNotificationDismiss($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const notification_r1 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("notification", notification_r1);
} }
/**
 * Notifier container component
 * ----------------------------
 * This component acts as a wrapper for all notification components; consequently, it is responsible for creating a new notification
 * component and removing an existing notification component. Being more precicely, it also handles side effects of those actions, such as
 * shifting or even completely removing other notifications as well. Overall, this components handles actions coming from the queue service
 * by subscribing to its action stream.
 *
 * Technical sidenote:
 * This component has to be used somewhere in an application to work; it will not inject and create itself automatically, primarily in order
 * to not break the Angular AoT compilation. Moreover, this component (and also the notification components) set their change detection
 * strategy onPush, which means that we handle change detection manually in order to get the best performance. (#perfmatters)
 */
class NotifierContainerComponent {
    /**
     * Constructor
     *
     * @param changeDetector       Change detector, used for manually triggering change detection runs
     * @param notifierQueueService Notifier queue service
     * @param notifierService      Notifier service
     */
    constructor(changeDetector, notifierQueueService, notifierService) {
        this.changeDetector = changeDetector;
        this.queueService = notifierQueueService;
        this.config = notifierService.getConfig();
        this.notifications = [];
        // Connects this component up to the action queue, then handle incoming actions
        this.queueServiceSubscription = this.queueService.actionStream.subscribe((action) => {
            this.handleAction(action).then(() => {
                this.queueService.continue();
            });
        });
    }
    /**
     * Component destroyment lifecycle hook, cleans up the observable subsciption
     */
    ngOnDestroy() {
        if (this.queueServiceSubscription) {
            this.queueServiceSubscription.unsubscribe();
        }
    }
    /**
     * Notification identifier, used as the ngFor trackby function
     *
     * @param   index        Index
     * @param   notification Notifier notification
     * @returns Notification ID as the unique identnfier
     */
    identifyNotification(index, notification) {
        return notification.id;
    }
    /**
     * Event handler, handles clicks on notification dismiss buttons
     *
     * @param notificationId ID of the notification to dismiss
     */
    onNotificationDismiss(notificationId) {
        this.queueService.push({
            payload: notificationId,
            type: 'HIDE'
        });
    }
    /**
     * Event handler, handles notification ready events
     *
     * @param notificationComponent Notification component reference
     */
    onNotificationReady(notificationComponent) {
        let currentNotification = this.notifications[this.notifications.length - 1]; // Get the latest notification
        currentNotification.component = notificationComponent; // Save the new omponent reference
        this.continueHandleShowAction(currentNotification); // Continue with handling the show action
    }
    /**
     * Handle incoming actions by mapping action types to methods, and then running them
     *
     * @param   action Action object
     * @returns Promise, resolved when done
     */
    handleAction(action) {
        switch (action.type) { // TODO: Maybe a map (actionType -> class method) is a cleaner solution here?
            case 'SHOW':
                return this.handleShowAction(action);
            case 'HIDE':
                return this.handleHideAction(action);
            case 'HIDE_OLDEST':
                return this.handleHideOldestAction(action);
            case 'HIDE_NEWEST':
                return this.handleHideNewestAction(action);
            case 'HIDE_ALL':
                return this.handleHideAllAction(action);
            default:
                return new Promise((resolve, reject) => {
                    resolve(); // Ignore unknown action types
                });
        }
    }
    /**
     * Show a new notification
     *
     * We simply add the notification to the list, and then wait until its properly initialized / created / rendered.
     *
     * @param   action Action object
     * @returns Promise, resolved when done
     */
    handleShowAction(action) {
        return new Promise((resolve, reject) => {
            this.tempPromiseResolver = resolve; // Save the promise resolve function so that it can be called later on by another method
            this.addNotificationToList(new NotifierNotification(action.payload));
        });
    }
    /**
     * Continue to show a new notification (after the notification components is initialized / created / rendered).
     *
     * If this is the first (and thus only) notification, we can simply show it. Otherwhise, if stacking is disabled (or a low value), we
     * switch out notifications, in particular we hide the existing one, and then show our new one. Yet, if stacking is enabled, we first
     * shift all older notifications, and then show our new notification. In addition, if there are too many notification on the screen,
     * we hide the oldest one first. Furthermore, if configured, animation overlapping is applied.
     *
     * @param notification New notification to show
     */
    continueHandleShowAction(notification) {
        // First (which means only one) notification in the list?
        const numberOfNotifications = this.notifications.length;
        if (numberOfNotifications === 1) {
            notification.component.show().then(this.tempPromiseResolver); // Done
        }
        else {
            const implicitStackingLimit = 2;
            // Stacking enabled? (stacking value below 2 means stacking is disabled)
            if (this.config.behaviour.stacking === false || this.config.behaviour.stacking < implicitStackingLimit) {
                this.notifications[0].component.hide().then(() => {
                    this.removeNotificationFromList(this.notifications[0]);
                    notification.component.show().then(this.tempPromiseResolver); // Done
                });
            }
            else {
                const stepPromises = [];
                // Are there now too many notifications?
                if (numberOfNotifications > this.config.behaviour.stacking) {
                    const oldNotifications = this.notifications.slice(1, numberOfNotifications - 1);
                    // Are animations enabled?
                    if (this.config.animations.enabled) {
                        // Is animation overlap enabled?
                        if (this.config.animations.overlap !== false && this.config.animations.overlap > 0) {
                            stepPromises.push(this.notifications[0].component.hide());
                            setTimeout(() => {
                                stepPromises.push(this.shiftNotifications(oldNotifications, notification.component.getHeight(), true));
                            }, this.config.animations.hide.speed - this.config.animations.overlap);
                            setTimeout(() => {
                                stepPromises.push(notification.component.show());
                            }, this.config.animations.hide.speed + this.config.animations.shift.speed - this.config.animations.overlap);
                        }
                        else {
                            stepPromises.push(new Promise((resolve, reject) => {
                                this.notifications[0].component.hide().then(() => {
                                    this.shiftNotifications(oldNotifications, notification.component.getHeight(), true).then(() => {
                                        notification.component.show().then(resolve);
                                    });
                                });
                            }));
                        }
                    }
                    else {
                        stepPromises.push(this.notifications[0].component.hide());
                        stepPromises.push(this.shiftNotifications(oldNotifications, notification.component.getHeight(), true));
                        stepPromises.push(notification.component.show());
                    }
                }
                else {
                    const oldNotifications = this.notifications.slice(0, numberOfNotifications - 1);
                    // Are animations enabled?
                    if (this.config.animations.enabled) {
                        // Is animation overlap enabled?
                        if (this.config.animations.overlap !== false && this.config.animations.overlap > 0) {
                            stepPromises.push(this.shiftNotifications(oldNotifications, notification.component.getHeight(), true));
                            setTimeout(() => {
                                stepPromises.push(notification.component.show());
                            }, this.config.animations.shift.speed - this.config.animations.overlap);
                        }
                        else {
                            stepPromises.push(new Promise((resolve, reject) => {
                                this.shiftNotifications(oldNotifications, notification.component.getHeight(), true).then(() => {
                                    notification.component.show().then(resolve);
                                });
                            }));
                        }
                    }
                    else {
                        stepPromises.push(this.shiftNotifications(oldNotifications, notification.component.getHeight(), true));
                        stepPromises.push(notification.component.show());
                    }
                }
                Promise.all(stepPromises).then(() => {
                    if (numberOfNotifications > this.config.behaviour.stacking) {
                        this.removeNotificationFromList(this.notifications[0]);
                    }
                    this.tempPromiseResolver();
                }); // Done
            }
        }
    }
    /**
     * Hide an existing notification
     *
     * Fist, we skip everything if there are no notifications at all, or the given notification does not exist. Then, we hide the given
     * notification. If there exist older notifications, we then shift them around to fill the gap. Once both hiding the given notification
     * and shifting the older notificaitons is done, the given notification gets finally removed (from the DOM).
     *
     * @param   action Action object, payload contains the notification ID
     * @returns Promise, resolved when done
     */
    handleHideAction(action) {
        return new Promise((resolve, reject) => {
            const stepPromises = [];
            // Does the notification exist / are there even any notifications? (let's prevent accidential errors)
            const notification = this.findNotificationById(action.payload);
            if (notification === undefined) {
                resolve();
                return;
            }
            // Get older notifications
            const notificationIndex = this.findNotificationIndexById(action.payload);
            if (notificationIndex === undefined) {
                resolve();
                return;
            }
            const oldNotifications = this.notifications.slice(0, notificationIndex);
            // Do older notifications exist, and thus do we need to shift other notifications as a consequence?
            if (oldNotifications.length > 0) {
                // Are animations enabled?
                if (this.config.animations.enabled && this.config.animations.hide.speed > 0) {
                    // Is animation overlap enabled?
                    if (this.config.animations.overlap !== false && this.config.animations.overlap > 0) {
                        stepPromises.push(notification.component.hide());
                        setTimeout(() => {
                            stepPromises.push(this.shiftNotifications(oldNotifications, notification.component.getHeight(), false));
                        }, this.config.animations.hide.speed - this.config.animations.overlap);
                    }
                    else {
                        notification.component.hide().then(() => {
                            stepPromises.push(this.shiftNotifications(oldNotifications, notification.component.getHeight(), false));
                        });
                    }
                }
                else {
                    stepPromises.push(notification.component.hide());
                    stepPromises.push(this.shiftNotifications(oldNotifications, notification.component.getHeight(), false));
                }
            }
            else {
                stepPromises.push(notification.component.hide());
            }
            // Wait until both hiding and shifting is done, then remove the notification from the list
            Promise.all(stepPromises).then(() => {
                this.removeNotificationFromList(notification);
                resolve(); // Done
            });
        });
    }
    /**
     * Hide the oldest notification (bridge to handleHideAction)
     *
     * @param   action Action object
     * @returns Promise, resolved when done
     */
    handleHideOldestAction(action) {
        // Are there any notifications? (prevent accidential errors)
        if (this.notifications.length === 0) {
            return new Promise((resolve, reject) => {
                resolve();
            }); // Done
        }
        else {
            action.payload = this.notifications[0].id;
            return this.handleHideAction(action);
        }
    }
    /**
     * Hide the newest notification (bridge to handleHideAction)
     *
     * @param   action Action object
     * @returns Promise, resolved when done
     */
    handleHideNewestAction(action) {
        // Are there any notifications? (prevent accidential errors)
        if (this.notifications.length === 0) {
            return new Promise((resolve, reject) => {
                resolve();
            }); // Done
        }
        else {
            action.payload = this.notifications[this.notifications.length - 1].id;
            return this.handleHideAction(action);
        }
    }
    /**
     * Hide all notifications at once
     *
     * @param   action Action object
     * @returns Promise, resolved when done
     */
    handleHideAllAction(action) {
        return new Promise((resolve, reject) => {
            // Are there any notifications? (prevent accidential errors)
            const numberOfNotifications = this.notifications.length;
            if (numberOfNotifications === 0) {
                resolve(); // Done
                return;
            }
            // Are animations enabled?
            if (this.config.animations.enabled && this.config.animations.hide.speed > 0 && this.config.animations.hide.offset !== false &&
                this.config.animations.hide.offset > 0) {
                for (let i = numberOfNotifications - 1; i >= 0; i--) {
                    const animationOffset = this.config.position.vertical.position === 'top' ? numberOfNotifications - 1 : i;
                    setTimeout(() => {
                        this.notifications[i].component.hide().then(() => {
                            // Are we done here, was this the last notification to be hidden?
                            if ((this.config.position.vertical.position === 'top' && i === 0) ||
                                (this.config.position.vertical.position === 'bottom' && i === numberOfNotifications - 1)) {
                                this.removeAllNotificationsFromList();
                                resolve(); // Done
                            }
                        });
                    }, this.config.animations.hide.offset * animationOffset);
                }
            }
            else {
                let stepPromises = [];
                for (let i = numberOfNotifications - 1; i >= 0; i--) {
                    stepPromises.push(this.notifications[i].component.hide());
                }
                Promise.all(stepPromises).then(() => {
                    this.removeAllNotificationsFromList();
                    resolve(); // Done
                });
            }
        });
    }
    /**
     * Shift multiple notifications at once
     *
     * @param   notifications List containing the notifications to be shifted
     * @param   distance      Distance to shift (in px)
     * @param   toMakePlace   Flag, defining in which direciton to shift
     * @returns Promise, resolved when done
     */
    shiftNotifications(notifications, distance, toMakePlace) {
        return new Promise((resolve, reject) => {
            // Are there any notifications to shift?
            if (notifications.length === 0) {
                resolve();
                return;
            }
            let notificationPromises = [];
            for (let i = notifications.length - 1; i >= 0; i--) {
                notificationPromises.push(notifications[i].component.shift(distance, toMakePlace));
            }
            Promise.all(notificationPromises).then(resolve); // Done
        });
    }
    /**
     * Add a new notification to the list of notifications (triggers change detection)
     *
     * @param notification Notification to add to the list of notifications
     */
    addNotificationToList(notification) {
        this.notifications.push(notification);
        this.changeDetector.markForCheck(); // Run change detection because the notification list changed
    }
    /**
     * Remove an existing notification from the list of notifications (triggers change detection)
     *
     * @param notification Notification to be removed from the list of notifications
     */
    removeNotificationFromList(notification) {
        this.notifications =
            this.notifications.filter((item) => item.component !== notification.component);
        this.changeDetector.markForCheck(); // Run change detection because the notification list changed
    }
    /**
     * Remove all notifications from the list (triggers change detection)
     */
    removeAllNotificationsFromList() {
        this.notifications = [];
        this.changeDetector.markForCheck(); // Run change detection because the notification list changed
    }
    /**
     * Helper: Find a notification in the notification list by a given notification ID
     *
     * @param   notificationId Notification ID, used for finding notification
     * @returns Notification, undefined if not found
     */
    findNotificationById(notificationId) {
        return this.notifications.find((currentNotification) => currentNotification.id === notificationId);
    }
    /**
     * Helper: Find a notification's index by a given notification ID
     *
     * @param   notificationId Notification ID, used for finding a notification's index
     * @returns Notification index, undefined if not found
     */
    findNotificationIndexById(notificationId) {
        const notificationIndex = this.notifications.findIndex((currentNotification) => currentNotification.id === notificationId);
        return (notificationIndex !== -1 ? notificationIndex : undefined);
    }
}
NotifierContainerComponent.ɵfac = function NotifierContainerComponent_Factory(t) { return new (t || NotifierContainerComponent)(ɵɵdirectiveInject(ChangeDetectorRef), ɵɵdirectiveInject(NotifierQueueService), ɵɵdirectiveInject(NotifierService)); };
NotifierContainerComponent.ɵcmp = ɵɵdefineComponent({ type: NotifierContainerComponent, selectors: [["notifier-container"]], hostAttrs: [1, "notifier__container"], decls: 2, vars: 2, consts: [["class", "notifier__container-list", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "notifier__container-list"], [3, "notification", "ready", "dismiss"]], template: function NotifierContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ul");
        ɵɵtemplate(1, NotifierContainerComponent_li_1_Template, 2, 1, "li", 0);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.notifications)("ngForTrackBy", ctx.identifyNotification);
    } }, directives: [NgForOf, NotifierNotificationComponent], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotifierContainerComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    class: 'notifier__container'
                },
                selector: 'notifier-container',
                templateUrl: './notifier-container.component.html'
            }]
    }], function () { return [{ type: ChangeDetectorRef }, { type: NotifierQueueService }, { type: NotifierService }]; }, null); })();

/**
 * Factory for a notifier configuration with custom options
 *
 * Sidenote:
 * Required as Angular AoT compilation cannot handle dynamic functions; see <https://github.com/angular/angular/issues/11262>.
 *
 * @param   options - Custom notifier options
 * @returns - Notifier configuration as result
 */
function notifierCustomConfigFactory(options) {
    return new NotifierConfig(options);
}
/**
 * Factory for a notifier configuration with default options
 *
 * Sidenote:
 * Required as Angular AoT compilation cannot handle dynamic functions; see <https://github.com/angular/angular/issues/11262>.
 *
 * @returns - Notifier configuration as result
 */
function notifierDefaultConfigFactory() {
    return new NotifierConfig({});
}
/**
 * Notifier module
 */
class NotifierModule {
    /**
     * Setup the notifier module with custom providers, in this case with a custom configuration based on the givne options
     *
     * @param   [options={}] - Custom notifier options
     * @returns - Notifier module with custom providers
     */
    static withConfig(options = {}) {
        return {
            ngModule: NotifierModule,
            providers: [
                // Provide the options itself upfront (as we need to inject them as dependencies -- see below)
                {
                    provide: NotifierOptionsToken,
                    useValue: options
                },
                // Provide a custom notifier configuration, based on the given notifier options
                {
                    deps: [
                        NotifierOptionsToken
                    ],
                    provide: NotifierConfigToken,
                    useFactory: notifierCustomConfigFactory
                }
            ]
        };
    }
}
NotifierModule.ɵmod = ɵɵdefineNgModule({ type: NotifierModule });
NotifierModule.ɵinj = ɵɵdefineInjector({ factory: function NotifierModule_Factory(t) { return new (t || NotifierModule)(); }, providers: [
        NotifierAnimationService,
        NotifierService,
        NotifierQueueService,
        // Provide the default notifier configuration if just the module is imported
        {
            provide: NotifierConfigToken,
            useFactory: notifierDefaultConfigFactory
        }
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(NotifierModule, { declarations: [NotifierContainerComponent,
        NotifierNotificationComponent], imports: [CommonModule], exports: [NotifierContainerComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotifierModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NotifierContainerComponent,
                    NotifierNotificationComponent
                ],
                exports: [
                    NotifierContainerComponent
                ],
                imports: [
                    CommonModule
                ],
                providers: [
                    NotifierAnimationService,
                    NotifierService,
                    NotifierQueueService,
                    // Provide the default notifier configuration if just the module is imported
                    {
                        provide: NotifierConfigToken,
                        useFactory: notifierDefaultConfigFactory
                    }
                ]
            }]
    }], null, null); })();

const _c0$1 = ["ctxMenu"];
function CtxMenuComponent_ng_template_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 3);
    ɵɵlistener("click", function CtxMenuComponent_ng_template_0_div_1_Template_div_click_0_listener($event) { ɵɵrestoreView(_r7); const action_r4 = ctx.$implicit; const item_r2 = ɵɵnextContext().$implicit; return action_r4.action($event, item_r2); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const action_r4 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(action_r4.description);
} }
function CtxMenuComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "section", 1);
    ɵɵtemplate(1, CtxMenuComponent_ng_template_0_div_1_Template, 2, 1, "div", 2);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", item_r2.actions);
} }
//  changeDetection: ChangeDetectionStrategy.OnPush,
class CtxMenuComponent {
    constructor(overlay, viewContainerRef) {
        this.overlay = overlay;
        this.viewContainerRef = viewContainerRef;
    }
    ctx_open({ x, y }, item) {
        try {
            this.ctx_close();
            const positionStrategy = this.overlay.position()
                .flexibleConnectedTo({ x, y })
                .withPositions([
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top',
                }
            ]);
            this.overlayRef = this.overlay.create({
                positionStrategy,
                scrollStrategy: this.overlay.scrollStrategies.close()
            });
            this.overlayRef.attach(new TemplatePortal(this.ctxMenu, this.viewContainerRef, {
                $implicit: item
            }));
            this.ctx_MouseEventSubscription = fromEvent(document, 'click')
                .pipe(filter(event => {
                const clickTarget = event.target;
                return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
            }), take(1)).subscribe(() => this.ctx_close());
        }
        catch (error) {
            console.error(error);
        }
    }
    ctx_close() {
        this.ctx_MouseEventSubscription && this.ctx_MouseEventSubscription.unsubscribe();
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }
}
CtxMenuComponent.ɵfac = function CtxMenuComponent_Factory(t) { return new (t || CtxMenuComponent)(ɵɵdirectiveInject(Overlay), ɵɵdirectiveInject(ViewContainerRef)); };
CtxMenuComponent.ɵcmp = ɵɵdefineComponent({ type: CtxMenuComponent, selectors: [["app-frms-ctxmenu"]], viewQuery: function CtxMenuComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$1, true);
    } if (rf & 2) {
        let _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.ctxMenu = _t.first);
    } }, decls: 2, vars: 0, consts: [["ctxMenu", ""], [1, "ctx-menu"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"]], template: function CtxMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, CtxMenuComponent_ng_template_0_Template, 2, 1, "ng-template", null, 0, ɵɵtemplateRefExtractor);
    } }, directives: [NgForOf], styles: [".ctx-menu[_ngcontent-%COMP%]{-webkit-animation:fadeIn .1s ease-out;animation:fadeIn .1s ease-out;background-color:#fafafa;border-radius:4pt;box-shadow:0 0 12pt rgba(0,0,0,.25);display:block;font-size:10pt;opacity:1;padding:.5em 0;z-index:1000}.ctx-menu[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border:none;border-bottom:1px solid #eee}.ctx-menu[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{color:#333;cursor:pointer;display:block;max-width:18em;overflow:hidden;padding:.5em 2em .5em .75em;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.ctx-menu[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:hover{background-color:#333;color:#fff}.ctx-menu[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:before{content:\"\";display:inline-block;float:left;height:1em;margin-right:.75em;width:.5em}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CtxMenuComponent, [{
        type: Component,
        args: [{
                selector: 'app-frms-ctxmenu',
                templateUrl: './ctxmenu.component.html',
                styleUrls: ['./ctxmenu.component.scss']
            }]
    }], function () { return [{ type: Overlay }, { type: ViewContainerRef }]; }, { ctxMenu: [{
            type: ViewChild,
            args: ['ctxMenu']
        }] }); })();

class AlertService {
    constructor(router) {
        this.router = router;
        this.subject = new Subject();
        this.keepAfterRouteChange = false;
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                }
                else {
                    // clear alert message
                    this.clearAll();
                }
            }
        });
    }
    // subscribe to alerts
    getAlert(alertId) {
        if (alertId) {
            //return this.subject.asObservable().filter((x: Alert) => x && x.alertId === alertId);
        }
        else {
            return this.subject.asObservable();
        }
    }
    // convenience methods
    success(message, timeout = 1000) {
        this.alert(new Alert({ message, type: AlertType.Success }));
    }
    error(message, timeout = 1000) {
        this.alert(new Alert({ message, type: AlertType.Error, timeout: timeout }));
    }
    info(message, timeout = 1000) {
        this.alert(new Alert({ message, type: AlertType.Info }));
    }
    warn(message, timeout = 1000) {
        this.alert(new Alert({ message, type: AlertType.Warning }));
    }
    // main alert method    
    alert(alert, timeout = 1000) {
        this.keepAfterRouteChange = alert.keepAfterRouteChange;
        this.subject.next(alert);
    }
    clearAll() {
        this.subject.next();
    }
    // clear alerts
    clear(alertId) {
        this.subject.next(new Alert({ alertId }));
    }
}
AlertService.ɵfac = function AlertService_Factory(t) { return new (t || AlertService)(ɵɵinject(Router)); };
AlertService.ɵprov = ɵɵdefineInjectable({ token: AlertService, factory: AlertService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AlertService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: Router }]; }, null); })();

class AlertModule {
}
AlertModule.ɵmod = ɵɵdefineNgModule({ type: AlertModule });
AlertModule.ɵinj = ɵɵdefineInjector({ factory: function AlertModule_Factory(t) { return new (t || AlertModule)(); }, providers: [
        AlertService
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AlertModule, { imports: [CommonModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AlertModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                exports: [],
                imports: [
                    CommonModule
                ],
                providers: [
                    AlertService
                ]
            }]
    }], null, null); })();

function MessagebarComponent_div_0_mat_progress_bar_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "mat-progress-bar", 5);
} }
function MessagebarComponent_div_0_div_3_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 9);
    ɵɵlistener("click", function MessagebarComponent_div_0_div_3_button_2_Template_button_click_0_listener() { ɵɵrestoreView(_r7); const alert_r3 = ɵɵnextContext().$implicit; const ctx_r5 = ɵɵnextContext(2); return ctx_r5.removeAlert(alert_r3); });
    ɵɵelementStart(1, "span", 10);
    ɵɵtext(2, "\u00D7");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function MessagebarComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 6);
    ɵɵlistener("click", function MessagebarComponent_div_0_div_3_Template_div_click_0_listener() { ɵɵrestoreView(_r9); const alert_r3 = ctx.$implicit; const ctx_r8 = ɵɵnextContext(2); return ctx_r8.removeAlert(alert_r3); });
    ɵɵelement(1, "div", 7);
    ɵɵtemplate(2, MessagebarComponent_div_0_div_3_button_2_Template, 3, 0, "button", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const alert_r3 = ctx.$implicit;
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵclassMapInterpolate2("divinside ", ctx_r2.compactclass, " ", ctx_r2.withpointerClass, "");
    ɵɵproperty("ngClass", alert_r3 == null ? null : alert_r3.cssClass)("matTooltip", ctx_r2.closeableTooltip);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", alert_r3 == null ? null : alert_r3.text, ɵɵsanitizeHtml);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.closeable);
} }
function MessagebarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "div", 2);
    ɵɵtemplate(2, MessagebarComponent_div_0_mat_progress_bar_2_Template, 1, 0, "mat-progress-bar", 3);
    ɵɵtemplate(3, MessagebarComponent_div_0_div_3_Template, 3, 8, "div", 4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r0.loading);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.messageList);
} }
//  changeDetection: ChangeDetectionStrategy.OnPush,
class MessagebarComponent {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        // message: any;
        this.dismissible = true;
        this.messageList = [];
        this.loading = false;
        /**
         * autoHideMillis in milliseconds
         */
        this.autoHideMillis = 0;
        this._closeable = true;
        this.withpointerClass = "";
        this.closeableTooltip = "";
        this.compactclass = "";
        /**
         * An event emitted when the close button is clicked. It has no payload and only relevant for dismissible alerts.
         */
        this.close = new EventEmitter();
    }
    get closeable() {
        return this._closeable;
    }
    set closeable(value) {
        this._closeable = value;
        if (value == true) {
            this.withpointerClass = "withpointer";
            this.closeableTooltip = "Click to close";
        }
        else {
            this.withpointerClass = "";
            this.closeableTooltip = "";
        }
    }
    set alertmessage(value) {
        this.addMessage(value);
    }
    set compact(value) {
        this.compactclass = "compact";
    }
    ngOnChanges(changes) {
        const typeChange = changes['alertmessage'];
        /*     if ((typeChange && !typeChange.firstChange) || typeChange.previousValue==undefined) {
              //this.alertmessage=typeChange.currentValue;
              console.log(this.alertmessage);
              this.alertmessage.text="ngOnChanges";
              console.log(this.alertmessage);
              //this.configMessage(this.alertmessage);
        
            } */
    }
    addMessage(value, forceRefresh = false) {
        if (!value) {
            this.messageList = [];
            return;
        }
        this.configMessage(value);
        this.messageList = [];
        this.messageList.push(value);
        if (forceRefresh) {
            this.changeDetectorRef.detectChanges();
        }
        this.startAutoHideTimer();
        /*     console.log("message.length " + this.messageList.length , value);
            for (let x=0;x<this.messageList.length;x++){
              console.log("message x=" + x , this.messageList[x]);
            } */
    }
    removeAlert(alert) {
        // remove specified alert from array
        this.messageList = this.messageList.filter(x => x !== alert);
        console.log("message.length " + this.messageList.length);
    }
    configMessage(messageReceived) {
        if (!messageReceived || messageReceived.cssClass != null) {
            return;
        }
        switch (messageReceived.type) {
            case AlertType.Success:
                messageReceived.cssClass = 'alert alert-dismissible alert-success';
                break;
            case AlertType.Error:
                messageReceived.cssClass = 'alert alert-dismissible alert-danger';
                break;
            case AlertType.Warning:
                messageReceived.cssClass = 'alert alert-dismissible alert-warning';
                break;
            case AlertType.Info:
                messageReceived.cssClass = 'alert alert-dismissible alert-info';
                break;
            default:
                messageReceived.cssClass = 'alert alert-dismissible alert-danger';
                break;
        }
    }
    onClosed() {
        this.alertmessage = null;
    }
    /**
  * Start the auto hide timer (if enabled)
  */
    startAutoHideTimer() {
        if (this.autoHideMillis > 0) {
            this.autoHideAlert(this.autoHideMillis);
        }
    }
    autoHideAlert(duration) {
        let cls = this;
        setTimeout(function () {
            cls.removeAlert(cls.alertmessage);
        }, duration);
    }
}
MessagebarComponent.ɵfac = function MessagebarComponent_Factory(t) { return new (t || MessagebarComponent)(ɵɵdirectiveInject(ChangeDetectorRef)); };
MessagebarComponent.ɵcmp = ɵɵdefineComponent({ type: MessagebarComponent, selectors: [["app-frms-messagebar"]], inputs: { loading: "loading", autoHideMillis: "autoHideMillis", closeable: "closeable", alertmessage: "alertmessage", compact: "compact" }, outputs: { close: "close" }, features: [ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "messagebar-container", 4, "ngIf"], [1, "messagebar-container"], [1, "messagebar-container-relative"], ["mode", "indeterminate", 4, "ngIf"], ["role", "alert", 3, "class", "ngClass", "matTooltip", "click", 4, "ngFor", "ngForOf"], ["mode", "indeterminate"], ["role", "alert", 3, "ngClass", "matTooltip", "click"], [3, "innerHTML"], ["type", "button", "class", "close", "data-dismiss", "alert", "aria-label", "Close", 3, "click", 4, "ngIf"], ["type", "button", "data-dismiss", "alert", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"]], template: function MessagebarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, MessagebarComponent_div_0_Template, 4, 2, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.messageList.length > 0);
    } }, directives: [NgIf, NgForOf, MatProgressBar, NgClass, MatTooltip], styles: [".messagebar-container[_ngcontent-%COMP%]{min-height:0;position:relative}.messagebar-container[_ngcontent-%COMP%], .messagebar-container-relative[_ngcontent-%COMP%]{margin:0;padding:0;right:0;top:0;width:100%;z-index:1000}.messagebar-container-relative[_ngcontent-%COMP%]{min-height:5rem;position:absolute}.divinside[_ngcontent-%COMP%]{position:relative;width:100%;z-index:1000}.compact[_ngcontent-%COMP%]{font-size:.8em;padding:.5em}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MessagebarComponent, [{
        type: Component,
        args: [{
                selector: 'app-frms-messagebar',
                templateUrl: './messagebar.component.html',
                styleUrls: ['./messagebar.component.css'],
                changeDetection: ChangeDetectionStrategy.Default
            }]
    }], function () { return [{ type: ChangeDetectorRef }]; }, { loading: [{
            type: Input
        }], autoHideMillis: [{
            type: Input
        }], closeable: [{
            type: Input
        }], alertmessage: [{
            type: Input
        }], compact: [{
            type: Input
        }], close: [{
            type: Output
        }] }); })();

class MessagebarModule {
}
MessagebarModule.ɵmod = ɵɵdefineNgModule({ type: MessagebarModule });
MessagebarModule.ɵinj = ɵɵdefineInjector({ factory: function MessagebarModule_Factory(t) { return new (t || MessagebarModule)(); }, imports: [[
            CommonModule,
            MatProgressBarModule,
            MatTooltipModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(MessagebarModule, { declarations: [MessagebarComponent], imports: [CommonModule,
        MatProgressBarModule,
        MatTooltipModule], exports: [MessagebarComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(MessagebarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatProgressBarModule,
                    MatTooltipModule
                ],
                declarations: [
                    MessagebarComponent
                ],
                entryComponents: [],
                exports: [
                    MessagebarComponent
                ]
            }]
    }], null, null); })();

class FrmFieldobjComponent {
    constructor() {
        this.myplaceholder = '';
        this.tt_description = '';
        this.isSelectable = false;
        this.useexternalclick = true;
        this.txttoshow = '';
        //@Output()clickevent=new EventEmitter<Property>();
        //@Output()modelchangeevent=new EventEmitter<Property>();
        this.isclickable = " withpointer ";
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (this.isSelectable) {
            this.isclickable = "withpointer";
            this.tt_description = "Click here to change.";
        }
        else {
            this.isclickable = "";
            this.tt_description = "";
        }
    }
    changeitem() {
        if (!this.isSelectable || this.useexternalclick == true) {
            return;
        }
        //this.clickevent.next(this.model);
        //this.openDialogForNewPropertySelection();
    }
}
FrmFieldobjComponent.ɵfac = function FrmFieldobjComponent_Factory(t) { return new (t || FrmFieldobjComponent)(); };
FrmFieldobjComponent.ɵcmp = ɵɵdefineComponent({ type: FrmFieldobjComponent, selectors: [["frms-frm-fieldobj"]], inputs: { myplaceholder: "myplaceholder", tt_description: "tt_description", model: "model", isSelectable: "isSelectable", useexternalclick: "useexternalclick", txttoshow: "txttoshow" }, features: [ɵɵNgOnChangesFeature], decls: 6, vars: 6, consts: [[2, "width", "100%", 3, "matTooltip"], [1, "box-inline1", 2, "width", "100%"], ["matInput", "", "type", "text", "readonly", "", 3, "placeholder", "value"], ["matSuffix", ""]], template: function FrmFieldobjComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "mat-form-field");
        ɵɵelement(3, "input", 2);
        ɵɵelementStart(4, "mat-icon", 3);
        ɵɵtext(5, "mode_edit");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassMapInterpolate1("", ctx.isclickable, " d-inline-flex");
        ɵɵpropertyInterpolate("matTooltip", ctx.tt_description);
        ɵɵadvance(3);
        ɵɵpropertyInterpolate("placeholder", ctx.myplaceholder);
        ɵɵpropertyInterpolate("value", ctx.txttoshow);
    } }, directives: [MatTooltip, MatFormField, MatInput, MatIcon, MatSuffix], styles: [".withpointer[_ngcontent-%COMP%], .withpointer[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{cursor:pointer!important}.box-inline[_ngcontent-%COMP%]{display:inline-block}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FrmFieldobjComponent, [{
        type: Component,
        args: [{
                selector: 'frms-frm-fieldobj',
                templateUrl: './frm-fieldobj.component.html',
                styleUrls: ['./frm-fieldobj.component.scss']
            }]
    }], function () { return []; }, { myplaceholder: [{
            type: Input
        }], tt_description: [{
            type: Input
        }], model: [{
            type: Input
        }], isSelectable: [{
            type: Input
        }], useexternalclick: [{
            type: Input
        }], txttoshow: [{
            type: Input
        }] }); })();

const _c0$2 = ["filterby"];
const _c1 = ["allSelected"];
function FilterlistComponent_ng_container_2_mat_option_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "mat-option", 8, 9);
    ɵɵlistener("click", function FilterlistComponent_ng_container_2_mat_option_3_Template_mat_option_click_0_listener() { ɵɵrestoreView(_r8); ɵɵnextContext(); const _r3 = ɵɵreference(2); const ctx_r7 = ɵɵnextContext(); return ctx_r7.toggleAllSelection(_r3); });
    ɵɵtext(2, "All");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵproperty("value", -1);
} }
function FilterlistComponent_ng_container_2_mat_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-option", 10);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵproperty("value", ctx_r5.GetPropertyValue(item_r9, ctx_r5.mylist_value));
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r5.GetPropertyValue(item_r9, ctx_r5.mylist_viewvalue), " ");
} }
function FilterlistComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "mat-select", 3, 4);
    ɵɵlistener("selectionChange", function FilterlistComponent_ng_container_2_Template_mat_select_selectionChange_1_listener($event) { ɵɵrestoreView(_r11); const ctx_r10 = ɵɵnextContext(); return ctx_r10.onRowClicked($event.value); });
    ɵɵtemplate(3, FilterlistComponent_ng_container_2_mat_option_3_Template, 3, 1, "mat-option", 5);
    ɵɵelementContainerStart(4, 6);
    ɵɵtemplate(5, FilterlistComponent_ng_container_2_mat_option_5_Template, 2, 2, "mat-option", 7);
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("placeholder", ctx_r0.myplaceholder);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r0.add_all_flag);
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r0.mylist);
} }
function FilterlistComponent_ng_template_3_mat_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-option", 10);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const ctx_r13 = ɵɵnextContext(2);
    ɵɵproperty("value", ctx_r13.GetPropertyValue(item_r14, ctx_r13.mylist_value));
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r13.GetPropertyValue(item_r14, ctx_r13.mylist_viewvalue), " ");
} }
function FilterlistComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "mat-select", 11, 4);
    ɵɵlistener("selectionChange", function FilterlistComponent_ng_template_3_Template_mat_select_selectionChange_0_listener($event) { ɵɵrestoreView(_r16); const ctx_r15 = ɵɵnextContext(); return ctx_r15.onRowClicked($event.value); });
    ɵɵtemplate(2, FilterlistComponent_ng_template_3_mat_option_2_Template, 2, 2, "mat-option", 7);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("placeholder", ctx_r2.myplaceholder);
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r2.mylist);
} }
class FilterlistComponent {
    constructor(fb) {
        this.fb = fb;
        this.add_all_flag = false;
        this.myplaceholder = "";
        this.mylist = [];
        this.onFilterChange = new EventEmitter();
    }
    ngOnInit() {
        if (this.add_all_flag) {
        }
        /*     this.searchUserForm = this.fb.group({
              userType: new FormControl('')
            }); */
    }
    getSelectBy() {
        if (this.filterby != null) {
            return this.filterby.value;
        }
        else {
            return null;
        }
    }
    fetchFromObject(obj, prop) {
        if (typeof obj === 'undefined') {
            return null;
        }
        if (obj == null) {
            return null;
        }
        let _index = prop.indexOf('.');
        if (_index > -1) {
            let field1 = prop.substring(0, _index);
            let field2 = prop.substr(_index + 1);
            let res = this.fetchFromObject(obj[field1], field2);
            return res;
        }
        return obj[prop];
    }
    GetPropertyValue(obj1, dataToRetrieve) {
        return dataToRetrieve
            .split('.') // split string based on `.`
            .reduce(function (o, k) {
            return o && o[k]; // get inner property if `o` is defined else get `o` and return
        }, obj1); // set initial value as object
    }
    onRowClicked(item) {
        console.log('onRowClicked', item);
        this.onFilterChange.emit(item);
    }
    toggleAllSelection(select) {
        console.log('select1', select);
        if (this.allSelected.selected) {
            this.filterby.options.forEach(function (item) {
                if (item.value != "-1") {
                    item.select();
                }
            });
        }
        else {
            this.filterby.options.forEach(function (item) {
                if (item.value != "-1") {
                    item.deselect();
                }
            });
        }
        let vals = this.getoptionsselected(this.filterby);
        this.onFilterChange.emit(vals);
    }
    getoptionsselected(select) {
        let options = select.options;
        let unitsarr = options.map(function (matoption) {
            if (matoption.selected) {
                return matoption.value;
            }
        });
        return unitsarr;
    }
}
FilterlistComponent.ɵfac = function FilterlistComponent_Factory(t) { return new (t || FilterlistComponent)(ɵɵdirectiveInject(FormBuilder)); };
FilterlistComponent.ɵcmp = ɵɵdefineComponent({ type: FilterlistComponent, selectors: [["frms-filterlist"]], viewQuery: function FilterlistComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$2, true);
        ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        let _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.filterby = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.allSelected = _t.first);
    } }, inputs: { add_all_flag: "add_all_flag", myplaceholder: "myplaceholder", mylist: "mylist", mylist_value: "mylist_value", mylist_viewvalue: "mylist_viewvalue", mylist_selectedvalue: "mylist_selectedvalue", mylist_ismultiple: "mylist_ismultiple" }, outputs: { onFilterChange: "onFilterChange" }, decls: 5, vars: 2, consts: [[1, "input-group", "no-border", "mr-2", 2, "float", "right", "width", "auto"], [4, "ngIf", "ngIfElse"], ["template_without", ""], ["multiple", "", 3, "placeholder", "selectionChange"], ["filterby", ""], [3, "value", "click", 4, "ngIf"], ["ngFor", "let item of mylist"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value", "click"], ["allSelected", ""], [3, "value"], [3, "placeholder", "selectionChange"]], template: function FilterlistComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "mat-form-field");
        ɵɵtemplate(2, FilterlistComponent_ng_container_2_Template, 6, 3, "ng-container", 1);
        ɵɵtemplate(3, FilterlistComponent_ng_template_3_Template, 3, 2, "ng-template", null, 2, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵɵreference(4);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.mylist_ismultiple)("ngIfElse", _r1);
    } }, directives: [MatFormField, NgIf, MatSelect, NgForOf, MatOption], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FilterlistComponent, [{
        type: Component,
        args: [{
                selector: 'frms-filterlist',
                templateUrl: './filterlist.component.html',
                styleUrls: ['./filterlist.component.scss']
            }]
    }], function () { return [{ type: FormBuilder }]; }, { add_all_flag: [{
            type: Input
        }], myplaceholder: [{
            type: Input
        }], mylist: [{
            type: Input
        }], mylist_value: [{
            type: Input
        }], mylist_viewvalue: [{
            type: Input
        }], mylist_selectedvalue: [{
            type: Input
        }], mylist_ismultiple: [{
            type: Input
        }], onFilterChange: [{
            type: Output
        }], filterby: [{
            type: ViewChild,
            args: ['filterby', { static: false }]
        }], allSelected: [{
            type: ViewChild,
            args: ['allSelected', { static: false }]
        }] }); })();

function DialogHeader1Component_ng_container_0_p_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r1.titlesub);
} }
function DialogHeader1Component_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 1);
    ɵɵelementStart(2, "div", 2);
    ɵɵelementStart(3, "h2");
    ɵɵelement(4, "div", 3);
    ɵɵelementEnd();
    ɵɵtemplate(5, DialogHeader1Component_ng_container_0_p_5_Template, 2, 1, "p", 0);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 4);
    ɵɵelementStart(7, "div", 5);
    ɵɵnamespaceSVG();
    ɵɵelementStart(8, "svg", 6);
    ɵɵelement(9, "path", 7);
    ɵɵelement(10, "path", 8);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ctx_r0.classtype);
    ɵɵadvance(3);
    ɵɵproperty("innerHTML", ctx_r0.title, ɵɵsanitizeHtml);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.titlesub);
} }
class DialogHeader1Component {
    constructor() {
        this.classtype = "";
    }
}
DialogHeader1Component.ɵfac = function DialogHeader1Component_Factory(t) { return new (t || DialogHeader1Component)(); };
DialogHeader1Component.ɵcmp = ɵɵdefineComponent({ type: DialogHeader1Component, selectors: [["app-layout-dialogheader1"]], inputs: { title: "title", titlesub: "titlesub", classtype: "classtype" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["cdkDrag", "", "cdkDragRootElement", ".cdk-overlay-pane", 1, "mat-dialog-title-1", 3, "ngClass"], [1, "title-1"], [3, "innerHTML"], [1, "dialog-toolbarcontainer"], ["cdkDragHandle", "", 1, "dialog-handle"], ["width", "24px", "fill", "currentColor", "viewBox", "0 0 24 24"], ["d", "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"], ["d", "M0 0h24v24H0z", "fill", "none"]], template: function DialogHeader1Component_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, DialogHeader1Component_ng_container_0_Template, 11, 3, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.title != null && ctx.title != "");
    } }, directives: [NgIf, CdkDrag, NgClass, CdkDragHandle], styles: [".mat-dialog-title-1[_ngcontent-%COMP%]{overflow:hidden}.mat-dialog-title-1[_ngcontent-%COMP%]   .title-1[_ngcontent-%COMP%]{float:left}.dialog-toolbarcontainer[_ngcontent-%COMP%]{float:right}.dialog-toolbarcontainer[_ngcontent-%COMP%]   .dialog-handle[_ngcontent-%COMP%]{color:#ccc;cursor:move;height:24px;width:24px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogHeader1Component, [{
        type: Component,
        args: [{
                selector: 'app-layout-dialogheader1',
                templateUrl: './dialog-header1.html',
                styleUrls: ['./dialog-header1.scss']
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], titlesub: [{
            type: Input
        }], classtype: [{
            type: Input
        }] }); })();

function DialogLessHeaderComponent_ng_container_0_p_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r1.titlesub);
} }
function DialogLessHeaderComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 1);
    ɵɵelementStart(2, "div", 2);
    ɵɵelementStart(3, "h2");
    ɵɵelement(4, "div", 3);
    ɵɵelementEnd();
    ɵɵtemplate(5, DialogLessHeaderComponent_ng_container_0_p_5_Template, 2, 1, "p", 0);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ctx_r0.classtype);
    ɵɵadvance(3);
    ɵɵproperty("innerHTML", ctx_r0.title, ɵɵsanitizeHtml);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.titlesub);
} }
class DialogLessHeaderComponent extends DialogHeader1Component {
    constructor() {
        super();
    }
}
DialogLessHeaderComponent.ɵfac = function DialogLessHeaderComponent_Factory(t) { return new (t || DialogLessHeaderComponent)(); };
DialogLessHeaderComponent.ɵcmp = ɵɵdefineComponent({ type: DialogLessHeaderComponent, selectors: [["app-layout-dialogLessheader"]], features: [ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "mat-dialog-title-1", 3, "ngClass"], [1, "title-1"], [3, "innerHTML"]], template: function DialogLessHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, DialogLessHeaderComponent_ng_container_0_Template, 6, 3, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.title != null && ctx.title != "");
    } }, directives: [NgIf, NgClass], styles: [""], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogLessHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'app-layout-dialogLessheader',
                templateUrl: './dialogless-header.html',
                styleUrls: ['./dialogless-header.scss'],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, null); })();

class DialogQuestionComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.lockdelete = false;
        this.loading = false;
        this.alertmessage = [];
        this.closeAftermainActionEmitter = false;
        this.btnCancelDescription = "Cancel";
        this.mainActionEmitter = new EventEmitter();
        //console.log("DialogQuestionComponent constructor :", data)
        this.modelinfo = data.model;
        this.closeAftermainActionEmitter = data.closeAftermainActionEmitter;
        if (data.btnCancelDescription) {
            this.btnCancelDescription = data.btnCancelDescription;
        }
    }
    onNoClick() {
        this.dialogRef.close();
    }
    showMessage() {
    }
    lockdeletebtn() {
        this.lockdelete = true;
    }
    dialoginprocess() {
        this.loading = true;
    }
    addmessage(type, message) {
        this.alertmessage.push();
    }
    setmessage(type, message) {
        this.alertmessage.push();
    }
    onActionOk() {
        this.mainActionEmitter.emit(this.modelinfo);
        if (this.closeAftermainActionEmitter == true) {
            this.dialogRef.close(this.data.actionvalue);
        }
    }
    static openDialog(dialog, title, message, model, actioncaption) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "500px";
        if (!actioncaption) {
            actioncaption = "Ok";
        }
        dialogConfig.data = { model: model, title: title, message: message, actioncaption: actioncaption };
        return dialog.open(DialogQuestionComponent, dialogConfig);
    }
}
DialogQuestionComponent.ɵfac = function DialogQuestionComponent_Factory(t) { return new (t || DialogQuestionComponent)(ɵɵdirectiveInject(MatDialogRef), ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
DialogQuestionComponent.ɵcmp = ɵɵdefineComponent({ type: DialogQuestionComponent, selectors: [["app-dialogquestion"]], outputs: { mainActionEmitter: "mainActionEmitter" }, decls: 17, vars: 6, consts: [[1, "card", "card-dialog"], [1, "card-header", "card-header-info", "card-header-icon", "card-icon-outside"], [1, "card-icon"], [1, "far", "fa-question-circle"], [1, "card-title"], [1, ""], [1, "card-body"], [3, "innerHTML"], [1, "clearfix"], [1, "card-footer", "text-right"], [2, "width", "100%"], ["mat-raised-button", "", 1, "btn", "btn-primary", "pull-right", "mr-2", 3, "disabled", "click"], ["mat-raised-button", "", "mat-dialog-close", "", 1, "btn", "btn-secondary", "pull-right", "mr-2", 3, "click"]], template: function DialogQuestionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelement(3, "i", 3);
        ɵɵelementEnd();
        ɵɵelementStart(4, "h3", 4);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementStart(6, "p", 5);
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 6);
        ɵɵelement(9, "div", 7);
        ɵɵelement(10, "div", 8);
        ɵɵelementEnd();
        ɵɵelementStart(11, "div", 9);
        ɵɵelementStart(12, "div", 10);
        ɵɵelementStart(13, "button", 11);
        ɵɵlistener("click", function DialogQuestionComponent_Template_button_click_13_listener() { return ctx.onActionOk(); });
        ɵɵtext(14);
        ɵɵelementEnd();
        ɵɵelementStart(15, "button", 12);
        ɵɵlistener("click", function DialogQuestionComponent_Template_button_click_15_listener() { return ctx.onNoClick(); });
        ɵɵtext(16);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵtextInterpolate(ctx.data.title);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.data == null ? null : ctx.data.titlesub);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ctx.data.message, ɵɵsanitizeHtml);
        ɵɵadvance(4);
        ɵɵproperty("disabled", ctx.lockdelete);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.data.actioncaption);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.btnCancelDescription);
    } }, directives: [MatButton, MatDialogClose], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogQuestionComponent, [{
        type: Component,
        args: [{
                selector: 'app-dialogquestion',
                templateUrl: './dialogquestion.component.html',
                styleUrls: ['./dialogquestion.component.scss']
            }]
    }], function () { return [{ type: MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { mainActionEmitter: [{
            type: Output
        }] }); })();

class DialogdeleteComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.lockdelete = false;
        this.loading = false;
        this.alertmessage = [];
        this.closeAftermainActionEmitter = false;
        this.mainActionEmitter = new EventEmitter();
        console.log("DialogdeleteComponent constructor :", data.model);
        this.modelinfo = data.model;
        this.closeAftermainActionEmitter = data.closeAftermainActionEmitter;
    }
    onNoClick() {
        this.dialogRef.close();
    }
    showMessage() {
    }
    lockdeletebtn() {
        this.lockdelete = true;
    }
    dialoginprocess() {
        this.loading = true;
    }
    addmessage(type, message) {
        this.alertmessage.push();
    }
    setmessage(type, message) {
        this.alertmessage.push();
    }
    onActionOk() {
        this.mainActionEmitter.emit(this.modelinfo);
        if (this.closeAftermainActionEmitter == true) {
            this.dialogRef.close(this.data.actionvalue);
        }
    }
    static openDialogDelete(dialog, title, message, model, actioncaption = "Delete", dialogConfig) {
        if (!dialogConfig) {
            dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = false;
            dialogConfig.autoFocus = true;
            dialogConfig.width = "500px";
        }
        dialogConfig.data = { model: model, title: title, message: message, actioncaption: actioncaption };
        return dialog.open(DialogdeleteComponent, dialogConfig);
    }
}
DialogdeleteComponent.ɵfac = function DialogdeleteComponent_Factory(t) { return new (t || DialogdeleteComponent)(ɵɵdirectiveInject(MatDialogRef), ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
DialogdeleteComponent.ɵcmp = ɵɵdefineComponent({ type: DialogdeleteComponent, selectors: [["app-dialogdelete"]], outputs: { mainActionEmitter: "mainActionEmitter" }, decls: 15, vars: 4, consts: [[1, "card", "card-dialog"], [1, "card-header", "card-header-danger", "card-header-icon", "card-icon-outside"], [1, "card-icon"], [1, "fas", "fa-trash"], [1, "card-title"], [1, "card-body"], [3, "innerHTML"], [1, "clearfix"], [1, "card-footer", "text-right"], [2, "width", "100%"], ["mat-raised-button", "", 1, "btn", "btn-danger", "pull-right", "mr-2", 3, "disabled", "click"], ["mat-raised-button", "", "mat-dialog-close", "", 1, "btn", "btn-secondary", "pull-right", "mr-2", 3, "click"]], template: function DialogdeleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelement(3, "i", 3);
        ɵɵelementEnd();
        ɵɵelementStart(4, "h3", 4);
        ɵɵtext(5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 5);
        ɵɵelement(7, "div", 6);
        ɵɵelement(8, "div", 7);
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", 8);
        ɵɵelementStart(10, "div", 9);
        ɵɵelementStart(11, "button", 10);
        ɵɵlistener("click", function DialogdeleteComponent_Template_button_click_11_listener() { return ctx.onActionOk(); });
        ɵɵtext(12);
        ɵɵelementEnd();
        ɵɵelementStart(13, "button", 11);
        ɵɵlistener("click", function DialogdeleteComponent_Template_button_click_13_listener() { return ctx.onNoClick(); });
        ɵɵtext(14, "Close");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵtextInterpolate(ctx.data.title);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ctx.data.message, ɵɵsanitizeHtml);
        ɵɵadvance(4);
        ɵɵproperty("disabled", ctx.lockdelete);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.data.actioncaption);
    } }, directives: [MatButton, MatDialogClose], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogdeleteComponent, [{
        type: Component,
        args: [{
                selector: 'app-dialogdelete',
                templateUrl: './dialogdelete.component.html',
                styleUrls: ['./dialogdelete.component.scss']
            }]
    }], function () { return [{ type: MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { mainActionEmitter: [{
            type: Output
        }] }); })();

class DialoginfoComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.title = "Info";
        this.titlesub = "";
        this.message = "";
        console.log("DialoginfoComponent constructor :", data.model);
        if (data.title != null) {
            this.title = data.title;
            if (data.titlesub != null) {
                this.titlesub = data.titlesub;
            }
        }
        this.message = data.message;
    }
    onNoClick() {
        this.dialogRef.close();
    }
    static opendialog(dialog, title, message, titlesub) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "500px";
        dialogConfig.data = { component: DialoginfoComponent, title: title, message: message, titlesub: titlesub };
        let dialogRef;
        dialogRef = dialog.open(DialoginfoComponent, dialogConfig);
        return dialogRef;
    }
}
DialoginfoComponent.ɵfac = function DialoginfoComponent_Factory(t) { return new (t || DialoginfoComponent)(ɵɵdirectiveInject(MatDialogRef), ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
DialoginfoComponent.ɵcmp = ɵɵdefineComponent({ type: DialoginfoComponent, selectors: [["app-dialoginfo"]], decls: 9, vars: 3, consts: [[3, "title", "titlesub"], [1, "row"], [1, "col-md-12", 2, "padding-top", "30px", "padding-bottom", "25px"], [3, "innerHTML"], [1, "clearfix"], ["mat-raised-button", "", "mat-dialog-close", "", 1, "btn", "pull-right"]], template: function DialoginfoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "app-layout-dialogheader1", 0);
        ɵɵelementStart(1, "mat-dialog-content");
        ɵɵelementStart(2, "div", 1);
        ɵɵelementStart(3, "div", 2);
        ɵɵelement(4, "div", 3);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(5, "div", 4);
        ɵɵelementEnd();
        ɵɵelementStart(6, "mat-dialog-actions");
        ɵɵelementStart(7, "button", 5);
        ɵɵtext(8, "Close");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("title", ctx.title)("titlesub", ctx.titlesub);
        ɵɵadvance(4);
        ɵɵproperty("innerHTML", ctx.message, ɵɵsanitizeHtml);
    } }, directives: [DialogHeader1Component, MatDialogContent, MatDialogActions, MatButton, MatDialogClose], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialoginfoComponent, [{
        type: Component,
        args: [{
                selector: 'app-dialoginfo',
                templateUrl: './dialoginfo.component.html',
                styleUrls: ['./dialoginfo.component.scss']
            }]
    }], function () { return [{ type: MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class DialogsModule {
}
DialogsModule.ɵmod = ɵɵdefineNgModule({ type: DialogsModule });
DialogsModule.ɵinj = ɵɵdefineInjector({ factory: function DialogsModule_Factory(t) { return new (t || DialogsModule)(); }, imports: [[
            CommonModule,
            MaterialModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DialogsModule, { declarations: [DialogHeader1Component,
        DialogLessHeaderComponent,
        DialogQuestionComponent,
        DialogdeleteComponent,
        DialoginfoComponent], imports: [CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule], exports: [DialogHeader1Component,
        DialogLessHeaderComponent,
        DialogQuestionComponent,
        DialogdeleteComponent,
        DialoginfoComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DialogsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MaterialModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                declarations: [
                    DialogHeader1Component,
                    DialogLessHeaderComponent,
                    DialogQuestionComponent,
                    DialogdeleteComponent,
                    DialoginfoComponent
                ],
                entryComponents: [],
                exports: [
                    DialogHeader1Component,
                    DialogLessHeaderComponent,
                    DialogQuestionComponent,
                    DialogdeleteComponent,
                    DialoginfoComponent
                ]
            }]
    }], null, null); })();

//style: 'app-select-check-all .mat-checkbox-layout,  app-select-check-all .mat-checkbox-label {  width:100% !important;}` 
class AppCheckBoxComponent {
    constructor() {
        this.modelauto = true;
        this.indeterminate = true;
        this.text = 'Select All';
        this.checkedEvent = new EventEmitter();
    }
    toggleSelection(change) {
        console.log("toggleSelection", change, this.checked);
        if (change.checked) {
            if (this.modelauto) {
                this.checked = true;
            }
            this.checkedEvent.emit(true);
        }
        else {
            if (this.modelauto) {
                this.checked = false;
            }
            this.checkedEvent.emit(false);
        }
    }
}
AppCheckBoxComponent.ɵfac = function AppCheckBoxComponent_Factory(t) { return new (t || AppCheckBoxComponent)(); };
AppCheckBoxComponent.ɵcmp = ɵɵdefineComponent({ type: AppCheckBoxComponent, selectors: [["app-check-box"]], inputs: { checked: "checked", modelauto: "modelauto", indeterminate: "indeterminate", text: "text" }, outputs: { checkedEvent: "checkedEvent" }, decls: 3, vars: 3, consts: [[1, "mat-option", 3, "indeterminate", "ngModel", "ngModelChange", "click", "change"], ["chk", ""]], template: function AppCheckBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-checkbox", 0, 1);
        ɵɵlistener("ngModelChange", function AppCheckBoxComponent_Template_mat_checkbox_ngModelChange_0_listener($event) { return ctx.checked = $event; })("click", function AppCheckBoxComponent_Template_mat_checkbox_click_0_listener($event) { return $event.stopPropagation(); })("change", function AppCheckBoxComponent_Template_mat_checkbox_change_0_listener($event) { return ctx.toggleSelection($event); });
        ɵɵtext(2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("indeterminate", ctx.indeterminate)("ngModel", ctx.checked);
        ɵɵadvance(2);
        ɵɵtextInterpolate1(" ", ctx.text, " ");
    } }, directives: [MatCheckbox, NgControlStatus, NgModel], styles: [""], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AppCheckBoxComponent, [{
        type: Component,
        args: [{
                selector: 'app-check-box',
                template: ` <mat-checkbox #chk class="mat-option" [indeterminate]="indeterminate" [(ngModel)]="checked" 
    (click) = "$event.stopPropagation()" (change) = "toggleSelection($event)" >
    {{ text }}
  </mat-checkbox>`,
                styleUrls: ['./app-check-box.component.scss'],
                encapsulation: ViewEncapsulation.None
            }]
    }], null, { checked: [{
            type: Input
        }], modelauto: [{
            type: Input
        }], indeterminate: [{
            type: Input
        }], text: [{
            type: Input
        }], checkedEvent: [{
            type: Output
        }] }); })();

const _c0$3 = function (a0, a1) { return [a0, a1]; };
//style: 'app-select-check-all .mat-checkbox-layout,  app-select-check-all .mat-checkbox-label {  width:100% !important;}` 
class AppCheckBoxIconComponent {
    constructor() {
        this._checked = false;
        this._class = "far fa-square";
        this._extraClass = "";
    }
    set checked(value) {
        this._checked = value;
        if (value) {
            this._class = "fas fa-check";
        }
        else {
            this._class = "far fa-square";
        }
    }
    get checked() {
        return this._checked;
    }
    set extraClass(value) {
        this._extraClass = value;
    }
    get extraClass() {
        return this._extraClass;
    }
    ngOnChanges(changes) {
        //console.log("AppCheckBoxIconComponent ngOnChanges " ,changes);
        /*         let typeChange = changes['imageUrlList'];
                if (typeChange && typeChange.currentValue != null) {
                  if (this.load_type == "ISSUES") {
                    //this.configureImagesByIssueList(typeChange.currentValue);
                  }
                } */
    }
}
AppCheckBoxIconComponent.ɵfac = function AppCheckBoxIconComponent_Factory(t) { return new (t || AppCheckBoxIconComponent)(); };
AppCheckBoxIconComponent.ɵcmp = ɵɵdefineComponent({ type: AppCheckBoxIconComponent, selectors: [["app-check-box-icon"]], inputs: { checked: "checked", extraClass: "extraClass" }, features: [ɵɵNgOnChangesFeature], decls: 1, vars: 4, consts: [[3, "ngClass"]], template: function AppCheckBoxIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "i", 0);
    } if (rf & 2) {
        ɵɵproperty("ngClass", ɵɵpureFunction2(1, _c0$3, ctx._class, ctx._extraClass));
    } }, directives: [NgClass], styles: [".green{color:green}.red{color:red}.fontx1,.fontx09{font-size:1em}"], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AppCheckBoxIconComponent, [{
        type: Component,
        args: [{
                selector: 'app-check-box-icon',
                template: `<i [ngClass]="[_class,_extraClass] "></i>`,
                styleUrls: ['app-check-box-icon.component.scss'],
                encapsulation: ViewEncapsulation.None
            }]
    }], null, { checked: [{
            type: Input
        }], extraClass: [{
            type: Input
        }] }); })();

const ALERTS = [{
        type: 'success',
    }, {
        type: 'info',
    }, {
        type: 'warning',
    }, {
        type: 'danger',
    }, {
        type: 'primary',
    }, {
        type: 'secondary',
    }, {
        type: 'light',
    }, {
        type: 'dark',
    }
];
class ErrorcontrolService {
    constructor(router, alertService) {
        this.router = router;
        this.alertService = alertService;
        //this.debugList = DebugList.list;
    }
    /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
    handleError(operation = 'operation', result) {
        return (error) => {
            console.error("ErrorcontrolService error for  " + operation, error);
            let fullmessage = "";
            if (typeof error === "string") {
                if (error == "Internal Server Error") {
                    fullmessage = "GeoAI Server returned an Internal server error. This must be checked with system administrators.";
                }
                else {
                    fullmessage = error;
                }
                error = new Error(fullmessage);
                return throwError(error || new Error('GEOAI server error'));
            }
            let httpErrorCode = error.httpErrorCode;
            if (httpErrorCode == null) {
                httpErrorCode = error.status;
            }
            console.error('ErrorcontrolService httpErrorCode:  ' + httpErrorCode);
            switch (httpErrorCode) {
                case UNAUTHORIZED:
                    //401
                    console.error('ErrorcontrolService UNAUTHORIZED ', error);
                    //this.authenticationService.logout();
                    //localStorage.removeItem('userToken');
                    //this.router.navigateByUrl('/login');
                    return throwError(error);
                case FORBIDDEN:
                    console.error('ErrorcontrolService FORBIDDEN', error);
                    //this.router.navigateByUrl("/login");
                    error.message = 'You don´t have permissions to access.';
                    return throwError(error);
                case BAD_REQUEST:
                    // this.showError(error.message);
                    //load message in fullmessage
                    return throwError(error);
            }
            if (error.error instanceof Error) {
                error.message = error.error.message;
                return throwError(error);
            }
            if (error instanceof HttpErrorResponse) {
                console.error('ErrorcontrolService error instanceof HttpErrorResponse ' + operation, error); // log to console instead
                if (typeof error.error === 'string') {
                    fullmessage = error.error;
                }
                else if (error.error instanceof Error) {
                    fullmessage = error.error.message;
                }
                else {
                    fullmessage = error.message;
                    if (error.statusText) {
                        fullmessage = error.statusText + " " + fullmessage;
                    }
                }
                if (error.url == null) {
                    return throwError(new Error('There is a problem with connection to the server.'));
                }
                if (error.error != null && error.error.ExceptionMessage != null) {
                    fullmessage += ' ' + error.error.ExceptionMessage;
                }
            }
            // Let the app keep running by returning an empty result.
            //return of(result as T);
            error.message = fullmessage;
            return throwError(error || new Error('GECO server error'));
        };
    }
    /** Log a ContactService message with the MessageService */
    log(message) {
        //this.messageService.add('ContactService: ' + message);
        console.log(message);
    }
    static getListhandleError(err) {
        let errbase = new ErrorBase();
        if (err instanceof HttpErrorResponse) {
            switch (err.status) {
                case 401:
                    console.error("UNAUTHORIZED");
                    errbase.type = "HttpErrorResponse";
                    errbase.msg = "UNAUTHORIZED";
                    return errbase;
            }
            errbase.type = "HttpErrorResponse";
            if (err.error != null) {
                if (typeof err.error === 'string') {
                    errbase.msg += " " + err.error;
                }
            }
            errbase.msg += " " + err.message;
        }
        else {
            if (err.error != null) {
                console.error(`Backend returned code ${err.status},body was: ${err.error}`);
            }
            errbase.type = "error";
            if (err.message != null) {
                errbase.msg = err.name + err.message;
            }
            if (err.error != null) {
                errbase.msg += err.error.message;
            }
        }
        return errbase;
    }
    static basichandleError(headermessage, err, alertService = null, tagDebug = "") {
        let msg = "";
        let returnMessage = "";
        if (err != null) {
            if (typeof err == 'string') {
                msg = err;
            }
            else if (err instanceof HttpErrorResponse) {
                let err_msg = err.message;
                if (err.statusText == "Unknown Error") {
                    msg = "GeoAI Server can not process your request. Please contact with system administrator. <br> " + err_msg;
                }
                else if (err.statusText == "Internal Server Error") {
                    msg = "GeoAI Internal Server Error. Please contact with system administrator.<br>" + err_msg;
                }
                if (err.error) {
                    msg += " " + ErrorServer.getErrorFormated(err.error);
                }
            }
            else if (err instanceof Error) {
                msg = err.message;
            }
            else {
                msg = err;
            }
            returnMessage = headermessage + " " + msg;
            /*       if (tagDebug != "") {
                    let tolog = DebugList.list.find(elem => elem.key === tagDebug);
                    if (tolog && tolog.debug) {
                      console.log(tagDebug, returnMessage);
                    }
                  } */
        }
        else {
            returnMessage = headermessage;
        }
        if (returnMessage != null && returnMessage.length > 0) {
            if (alertService != null) {
                alertService.notify(NotificationType.Error, returnMessage);
            }
        }
        return new MessageError(AlertType.Error, returnMessage);
    }
}
ErrorcontrolService.ɵfac = function ErrorcontrolService_Factory(t) { return new (t || ErrorcontrolService)(ɵɵinject(Router), ɵɵinject(AlertService)); };
ErrorcontrolService.ɵprov = ɵɵdefineInjectable({ token: ErrorcontrolService, factory: ErrorcontrolService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ErrorcontrolService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Router }, { type: AlertService }]; }, null); })();

class BaseModelComponent {
    constructor() {
        /*     //let injector =ReflectiveInjector.resolveAndCreate([MatDialog,Router,ActivatedRoute,AlertService,NotifierService]);
            const providersArray=[MatDialog,Router,ActivatedRoute,AlertService,NotifierService];
            const injector = Injector.create( {providers: [{provide: MatDialog},{provide: Router},{provide: ActivatedRoute},{provide: AlertService},{provide: NotifierService} ]} );
            if (injector) {
            this.dialog =   injector.get(MatDialog);
            this.router = injector.get(Router);
            //this.route = injector.get(ActivatedRoute);
            this.alertService = injector.get(AlertService);
            this.notifier = injector.get(NotifierService);
            }
            else{
              console.error("ERROR ON BASE COMPONENT. INJECTOR IS NULL");
            }   */
        /**
         * name to identify the class
         */
        this.TAG = "";
        this.iseditable = true;
        this.submitted = false;
        this.listOriginal = [];
        this._listFiltered = [];
        this.ismodal = false; //lo usamos cuando queremos mostrar el componente en un modal
        this.selectedevent = new EventEmitter();
        this.selectedItemEvent = new EventEmitter();
        this.loadinglist = true;
        this.editablemode = true;
        const injector = AppInjector.getInjector();
        if (injector) {
            this.dialog = injector.get(MatDialog);
            this.router = injector.get(Router);
            this.route = injector.get(ActivatedRoute);
            this.alertService = injector.get(AlertService);
            this.notifier = injector.get(NotifierService);
        }
        else {
            console.error("ERROR ON BASE COMPONENT. INJECTOR IS NULL");
        }
    }
    get listFiltered() {
        return this._listFiltered;
    }
    set listFiltered(value) {
        this._listFiltered = value;
    }
    get loading() {
        return this.loadinglist;
    }
    set loading(value) {
        this.loadinglist = value;
    }
    ngOnInit() { }
    uiiseditablemodel(element) {
        return true;
    }
    fake() {
    }
    clog(classnameMethod, logdesc, obj) {
        console.log(classnameMethod + " " + logdesc, obj);
    }
    handleSuccesLoad(message, alertype = AlertType.Success) {
        this.alertmessage = new MessageError(alertype, message);
        this.loadinglist = false;
    }
    handleLoadError(errorObject) {
        this.loadinglist = false;
        this.alertmessage = ErrorcontrolService.basichandleError("Error loading data", errorObject, null, this.TAG);
    }
    handleError(err, genericMessage = "") {
        this.loadinglist = false;
        this.alertmessage = ErrorcontrolService.basichandleError(genericMessage, err, null, this.TAG);
    }
    openDialogDelete(title, message, model) {
        return DialogdeleteComponent.openDialogDelete(this.dialog, title, message, model);
        //dialogRef.componentInstance.mainActionEmitter.subscribe(()=>myfunction(model,dialogRef));
    }
    openDialogQuestion(title, message, model) {
        return DialogQuestionComponent.openDialog(this.dialog, title, message, model);
        //dialogRef.componentInstance.mainActionEmitter.subscribe(()=>myfunction(model,dialogRef));
    }
    showmessage(message) {
        this.alertmessage = new MessageError(AlertType.Success, message);
    }
    showerror(message, err) {
        this.alertmessage = ErrorcontrolService.basichandleError(message, err, null, this.TAG);
    }
    notifyerror(err, genericMessage) {
        return ErrorcontrolService.basichandleError(genericMessage, err, this.notifier, this.TAG);
    }
    /**
       * Show a notification
       *
       * @param {string} type    Notification type
       * @param {string} message Notification message
       */
    showNotification(type, message) {
        this.notifier.notify(type, message);
    }
    showNotificationError(message, err) {
        //this.notifier.notify(NotificationType.Error, message);
        return ErrorcontrolService.basichandleError(message, err, this.notifier, this.TAG);
    }
    showNotificationInfo(message) {
        this.notifier.notify(NotificationType.Info, message);
    }
    showNotificationWarning(message) {
        this.notifier.notify(NotificationType.Warning, message);
    }
    showNotificationSuccess(message) {
        this.notifier.notify(NotificationType.Success, message);
    }
    /**
   * Hide oldest notification
   */
    hideOldestNotification() {
        this.notifier.hideOldest();
    }
    /**
       * Hide newest notification
       */
    hideNewestNotification() {
        this.notifier.hideNewest();
    }
    /**
   * Hide all notifications at once
   */
    hideAllNotifications() {
        this.notifier.hideAll();
    }
    /**
     * Show a specific notification (with a custom notification ID)
     *
     * @param {string} type    Notification type
     * @param {string} message Notification message
     * @param {string} id      Notification ID
     */
    showSpecificNotification(type, message, id) {
        this.notifier.show({
            id,
            message,
            type
        });
    }
    /**
     * Hide a specific notification (by a given notification ID)
     *
     * @param {string} id Notification ID
     */
    hideSpecificNotification(id) {
        this.notifier.hide(id);
    }
}
BaseModelComponent.ɵfac = function BaseModelComponent_Factory(t) { return new (t || BaseModelComponent)(); };
BaseModelComponent.ɵcmp = ɵɵdefineComponent({ type: BaseModelComponent, selectors: [["app-basemodel-comp"]], inputs: { ismodal: "ismodal", editablemode: "editablemode" }, outputs: { selectedevent: "selectedevent", selectedItemEvent: "selectedItemEvent" }, decls: 0, vars: 0, template: function BaseModelComponent_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BaseModelComponent, [{
        type: Component,
        args: [{
                selector: 'app-basemodel-comp',
                template: ''
            }]
    }], function () { return []; }, { ismodal: [{
            type: Input
        }], selectedevent: [{
            type: Output
        }], selectedItemEvent: [{
            type: Output
        }], editablemode: [{
            type: Input
        }] }); })();

class SearchBoxComponent {
    constructor() {
        this.loading = false;
        this.placeholder = "";
        this.tooltip = "";
        this.find_event = new EventEmitter();
        this.boxString = "";
    }
    changeEvent_handler(value) {
        this.boxString = value;
    }
    find_click() {
        this.find_event.next(this.boxString);
    }
}
SearchBoxComponent.ɵfac = function SearchBoxComponent_Factory(t) { return new (t || SearchBoxComponent)(); };
SearchBoxComponent.ɵcmp = ɵɵdefineComponent({ type: SearchBoxComponent, selectors: [["frms-searchbox"]], inputs: { placeholder: "placeholder", tooltip: "tooltip" }, outputs: { find_event: "find_event" }, decls: 9, vars: 2, consts: [[1, "search-container"], [1, "fa", "fa-search", "search-icon"], ["type", "text", 1, "form-control", "form-control-sm", "search-box", 3, "matTooltip", "placeholder", "input"], ["type", "button", "matTooltip", "Find", 1, "btn", "btn-sm", "btn-outline-primary", 3, "click"], [1, "fas", "fa-search"]], template: function SearchBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "table");
        ɵɵelementStart(2, "tr");
        ɵɵelementStart(3, "td");
        ɵɵelement(4, "i", 1);
        ɵɵelementStart(5, "input", 2);
        ɵɵlistener("input", function SearchBoxComponent_Template_input_input_5_listener($event) { return ctx.changeEvent_handler($event.target.value); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "td");
        ɵɵelementStart(7, "button", 3);
        ɵɵlistener("click", function SearchBoxComponent_Template_button_click_7_listener() { return ctx.find_click(); });
        ɵɵelement(8, "i", 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵpropertyInterpolate("matTooltip", ctx.tooltip);
        ɵɵproperty("placeholder", ctx.placeholder);
    } }, directives: [MatTooltip], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SearchBoxComponent, [{
        type: Component,
        args: [{
                selector: 'frms-searchbox',
                templateUrl: './searchbox.component.html',
                styleUrls: ['./searchbox.component.scss']
            }]
    }], function () { return []; }, { placeholder: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], find_event: [{
            type: Output
        }] }); })();

//style: 'app-select-check-all .mat-checkbox-layout,  app-select-check-all .mat-checkbox-label {  width:100% !important;}` 
class SelectCheckAllComponent {
    constructor() {
        this.checked = true;
        this.text = 'Select All';
    }
    /*     isChecked(): boolean {
            return this.select.
        } */
    isIndeterminate() {
        if (!this.select) {
            return true;
        }
        let selected = this.select.selectedOptions.selected.length;
        let allitems = this.select.options.length;
        if (selected < allitems) {
            return true;
        }
        else {
            return false;
        }
    }
    toggleSelection(change) {
        if (change.checked) {
            this.select.selectAll();
        }
        else {
            this.select.deselectAll();
        }
    }
}
SelectCheckAllComponent.ɵfac = function SelectCheckAllComponent_Factory(t) { return new (t || SelectCheckAllComponent)(); };
SelectCheckAllComponent.ɵcmp = ɵɵdefineComponent({ type: SelectCheckAllComponent, selectors: [["app-select-check-all"]], inputs: { checked: "checked", text: "text", select: "select" }, decls: 2, vars: 3, consts: [[1, "mat-option", 3, "indeterminate", "ngModel", "ngModelChange", "click", "change"]], template: function SelectCheckAllComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-checkbox", 0);
        ɵɵlistener("ngModelChange", function SelectCheckAllComponent_Template_mat_checkbox_ngModelChange_0_listener($event) { return ctx.checked = $event; })("click", function SelectCheckAllComponent_Template_mat_checkbox_click_0_listener($event) { return $event.stopPropagation(); })("change", function SelectCheckAllComponent_Template_mat_checkbox_change_0_listener($event) { return ctx.toggleSelection($event); });
        ɵɵtext(1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("indeterminate", ctx.isIndeterminate())("ngModel", ctx.checked);
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ctx.text, " ");
    } }, directives: [MatCheckbox, NgControlStatus, NgModel], styles: [""], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SelectCheckAllComponent, [{
        type: Component,
        args: [{
                selector: 'app-select-check-all',
                template: ` <mat-checkbox class="mat-option" [indeterminate]="isIndeterminate()" [(ngModel)]="checked" 
    (click) = "$event.stopPropagation()" (change) = "toggleSelection($event)" >
    {{ text }}
  </mat-checkbox>`,
                styleUrls: ['./select-check-all.component.css'],
                encapsulation: ViewEncapsulation.None
            }]
    }], null, { checked: [{
            type: Input
        }], text: [{
            type: Input
        }], select: [{
            type: Input
        }] }); })();

class P403Component {
    constructor() { }
}
P403Component.ɵfac = function P403Component_Factory(t) { return new (t || P403Component)(); };
P403Component.ɵcmp = ɵɵdefineComponent({ type: P403Component, selectors: [["ng-component"]], decls: 11, vars: 0, consts: [[1, "app", "flex-row", "align-items-center"], [1, "container"], [1, "row", "justify-content-center"], [1, "col-md-6"], [1, "clearfix"], [1, "float-left", "display-3", "mr-4"], [1, "pt-3"], [1, "text-muted"]], template: function P403Component_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "h1", 5);
        ɵɵtext(6, "403");
        ɵɵelementEnd();
        ɵɵelementStart(7, "h4", 6);
        ɵɵtext(8, "Oops! You don\u00B4t have permissions.");
        ɵɵelementEnd();
        ɵɵelementStart(9, "p", 7);
        ɵɵtext(10, "Ask your administrator");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(P403Component, [{
        type: Component,
        args: [{
                templateUrl: '403.component.html'
            }]
    }], function () { return []; }, null); })();

class P404Component {
    constructor() { }
}
P404Component.ɵfac = function P404Component_Factory(t) { return new (t || P404Component)(); };
P404Component.ɵcmp = ɵɵdefineComponent({ type: P404Component, selectors: [["ng-component"]], decls: 19, vars: 0, consts: [[1, "app", "flex-row", "align-items-center"], [1, "container"], [1, "row", "justify-content-center"], [1, "col-md-6"], [1, "clearfix"], [1, "float-left", "display-3", "mr-4"], [1, "pt-3"], [1, "text-muted"], [1, "input-prepend", "input-group"], [1, "input-group-prepend"], [1, "input-group-text"], [1, "fa", "fa-search"], ["id", "prependedInput", "size", "16", "type", "text", "placeholder", "What are you looking for?", 1, "form-control", "form-control-sm"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-info"]], template: function P404Component_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "h1", 5);
        ɵɵtext(6, "404");
        ɵɵelementEnd();
        ɵɵelementStart(7, "h4", 6);
        ɵɵtext(8, "Oops! You're lost.");
        ɵɵelementEnd();
        ɵɵelementStart(9, "p", 7);
        ɵɵtext(10, "The page you are looking for was not found.");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(11, "div", 8);
        ɵɵelementStart(12, "div", 9);
        ɵɵelementStart(13, "span", 10);
        ɵɵelement(14, "i", 11);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(15, "input", 12);
        ɵɵelementStart(16, "span", 13);
        ɵɵelementStart(17, "button", 14);
        ɵɵtext(18, "Search");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(P404Component, [{
        type: Component,
        args: [{
                templateUrl: '404.component.html'
            }]
    }], function () { return []; }, null); })();

class P500Component {
    constructor() { }
}
P500Component.ɵfac = function P500Component_Factory(t) { return new (t || P500Component)(); };
P500Component.ɵcmp = ɵɵdefineComponent({ type: P500Component, selectors: [["ng-component"]], decls: 19, vars: 0, consts: [[1, "app", "flex-row", "align-items-center"], [1, "container"], [1, "row", "justify-content-center"], [1, "col-md-6"], [1, "clearfix"], [1, "float-left", "display-3", "mr-4"], [1, "pt-3"], [1, "text-muted"], [1, "input-prepend", "input-group"], [1, "input-group-prepend"], [1, "input-group-text"], [1, "fa", "fa-search"], ["id", "prependedInput", "size", "16", "type", "text", "placeholder", "What are you looking for?", 1, "form-control"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-info"]], template: function P500Component_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "h1", 5);
        ɵɵtext(6, "500");
        ɵɵelementEnd();
        ɵɵelementStart(7, "h4", 6);
        ɵɵtext(8, "Houston, we have a problem!");
        ɵɵelementEnd();
        ɵɵelementStart(9, "p", 7);
        ɵɵtext(10, "The page you are looking for is temporarily unavailable.");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(11, "div", 8);
        ɵɵelementStart(12, "div", 9);
        ɵɵelementStart(13, "span", 10);
        ɵɵelement(14, "i", 11);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(15, "input", 12);
        ɵɵelementStart(16, "span", 13);
        ɵɵelementStart(17, "button", 14);
        ɵɵtext(18, "Search");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(P500Component, [{
        type: Component,
        args: [{
                templateUrl: '500.component.html'
            }]
    }], function () { return []; }, null); })();

class ErrorPagesModule {
}
ErrorPagesModule.ɵmod = ɵɵdefineNgModule({ type: ErrorPagesModule });
ErrorPagesModule.ɵinj = ɵɵdefineInjector({ factory: function ErrorPagesModule_Factory(t) { return new (t || ErrorPagesModule)(); }, imports: [[CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ErrorPagesModule, { declarations: [P404Component,
        P403Component,
        P500Component], imports: [CommonModule], exports: [P404Component,
        P403Component,
        P500Component] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ErrorPagesModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule
                ],
                declarations: [
                    P404Component,
                    P403Component,
                    P500Component,
                ],
                exports: [
                    P404Component,
                    P403Component,
                    P500Component,
                ]
            }]
    }], null, null); })();

function NavIconToggleComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵstyleProp("background-color", ctx_r0.color);
} }
const _c0$4 = function () { return [1, 2, 3]; };
class NavIconToggleComponent {
    constructor() {
        this.type = "icon-cross";
        this.tooltip = "Toggle side menu.";
        this.status = "open";
        this.color = '#8c8787'; // default color: #333
        this.toggled = new EventEmitter();
        this.classes = "";
    }
    get closed() {
        return this._closed;
    }
    set closed(value) {
        if (value) {
            this.status = "closed";
            this.classes = this.type + " " + this.status;
        }
        else {
            this.status = "open";
            this.classes = this.type + " " + this.status;
        }
        this._closed = value;
    }
    toggle() {
        if (this._closed) {
            this.status = "open";
            this.classes = this.type + " " + this.status;
            this._closed = false;
            this.toggled.emit();
            return;
        }
        else {
            this.status = "closed";
            this.classes = this.type + " " + this.status;
            this._closed = true;
            this.toggled.emit();
            return;
        }
    }
}
NavIconToggleComponent.ɵfac = function NavIconToggleComponent_Factory(t) { return new (t || NavIconToggleComponent)(); };
NavIconToggleComponent.ɵcmp = ɵɵdefineComponent({ type: NavIconToggleComponent, selectors: [["nav-icon-toggle"]], inputs: { type: "type", tooltip: "tooltip", closed: "closed", color: "color" }, outputs: { toggled: "toggled" }, decls: 3, vars: 4, consts: [[1, "nav-icon-container"], [1, "navicon", 3, "ngClass", "matTooltip", "click"], ["class", "navicon-bar", 3, "background-color", 4, "ngFor", "ngForOf"], [1, "navicon-bar"]], template: function NavIconToggleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵlistener("click", function NavIconToggleComponent_Template_div_click_1_listener() { return ctx.toggle(); });
        ɵɵtemplate(2, NavIconToggleComponent_span_2_Template, 1, 2, "span", 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ctx.classes)("matTooltip", ctx.tooltip);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ɵɵpureFunction0(3, _c0$4));
    } }, directives: [NgClass, MatTooltip, NgForOf], styles: [".nav-icon-container[_ngcontent-%COMP%]{height:1.2rem;margin-right:.1em;width:1.4rem}.nav-icon-container[_ngcontent-%COMP%]   .navicon[_ngcontent-%COMP%]{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;box-sizing:border-box;cursor:pointer;height:100%;padding:.3em;position:relative;user-select:none;width:100%}.nav-icon-container[_ngcontent-%COMP%]   .navicon-bar[_ngcontent-%COMP%]{display:block;height:.1em;position:absolute;transition:all .2s ease-out;width:100%}.nav-icon-container[_ngcontent-%COMP%]   .navicon-bar[_ngcontent-%COMP%]:first-child{top:.1em}.nav-icon-container[_ngcontent-%COMP%]   .navicon-bar[_ngcontent-%COMP%]:nth-child(2){top:50%;transform:translateY(-50%)}.nav-icon-container[_ngcontent-%COMP%]   .navicon-bar[_ngcontent-%COMP%]:last-child{bottom:.1em}.nav-icon-container[_ngcontent-%COMP%]   .navicon.open.icon-cross[_ngcontent-%COMP%] > .navicon-bar[_ngcontent-%COMP%]:first-child{top:1em;transform:rotate(45deg)}.nav-icon-container[_ngcontent-%COMP%]   .navicon.open.icon-cross[_ngcontent-%COMP%] > .navicon-bar[_ngcontent-%COMP%]:nth-child(2){background-color:transparent!important}.nav-icon-container[_ngcontent-%COMP%]   .navicon.open.icon-cross[_ngcontent-%COMP%] > .navicon-bar[_ngcontent-%COMP%]:last-child{bottom:1em;transform:rotate(-45deg)}.nav-icon-container[_ngcontent-%COMP%]   .navicon.open.arrow-left[_ngcontent-%COMP%] > .navicon-bar[_ngcontent-%COMP%]:first-child{top:0;transform:rotate(-45deg)}.nav-icon-container[_ngcontent-%COMP%]   .navicon.open.arrow-left[_ngcontent-%COMP%] > .navicon-bar[_ngcontent-%COMP%]:nth-child(2){background-color:transparent!important}.nav-icon-container[_ngcontent-%COMP%]   .navicon.open.arrow-left[_ngcontent-%COMP%] > .navicon-bar[_ngcontent-%COMP%]:last-child{bottom:.1em;transform:rotate(45deg)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NavIconToggleComponent, [{
        type: Component,
        args: [{
                selector: 'nav-icon-toggle',
                templateUrl: './nav-icon-toggle.component.html',
                styleUrls: ['./nav-icon-toggle.component.scss']
            }]
    }], null, { type: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], closed: [{
            type: Input
        }], color: [{
            type: Input
        }], toggled: [{
            type: Output
        }] }); })();

function BaseLoginComponent_div_25_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1, "Username is required");
    ɵɵelementEnd();
} }
function BaseLoginComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 28);
    ɵɵtemplate(1, BaseLoginComponent_div_25_div_1_Template, 2, 0, "div", 29);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.f.username.errors.required);
} }
function BaseLoginComponent_span_35_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 30);
} }
function BaseLoginComponent_app_frms_messagebar_38_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "app-frms-messagebar", 31);
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("alertmessage", ctx_r2.alertmessage);
} }
const _c0$5 = function (a0) { return { "is-invalid": a0 }; };
class BaseLoginComponent {
    constructor(formBuilder, route, router, authenticationService) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.authenticationService = authenticationService;
        this.loadinglist = false;
        this.submitted = false;
        this.isLoginError = true;
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
        else {
            this.authenticationService.logout();
        }
        this.appversion = "0.0.0"; //AppConfig.app_version;
    }
    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }
    ngOnInit() {
        let usertest = ""; //AppConfig.user_test;
        let userpwd = ""; //AppConfig.user_pwd;
        this.loginForm = this.formBuilder.group({
            username: [usertest, Validators.required],
            password: [userpwd, Validators.required]
        });
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }
    onSubmit() {
        if (this.loginForm.invalid) {
            return;
        }
        this.submitted = true;
        this.alertmessage = null;
        this.loadinglist = true;
        let hashpsw = Md5.hashStr(this.f.password.value);
        //console.log("fa6e85b573434c309b354aec004eb5ab",hashpsw);
        this.authenticationService.login(this.f.username.value, hashpsw)
            .pipe(first())
            .subscribe(data => {
            //console.log(data);
            this.router.navigate([this.returnUrl]);
        }, error => {
            //this.alertService.error(error);
            this.alertmessage = ErrorcontrolService.basichandleError("", error);
            ;
            this.loadinglist = false;
        });
    }
}
BaseLoginComponent.ɵfac = function BaseLoginComponent_Factory(t) { return new (t || BaseLoginComponent)(ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(AUTH_SERVICE_PROVIDER_TOKEN)); };
BaseLoginComponent.ɵcmp = ɵɵdefineComponent({ type: BaseLoginComponent, selectors: [["app-dashboard"]], features: [ɵɵProvidersFeature([Md5])], decls: 39, vars: 12, consts: [[1, "app-body"], [1, "main", "d-flex", "mainbox"], [1, "container", 2, "margin-top", "5%"], [1, "row"], [1, "col-md-6", "mx-auto"], [1, "welcome"], [1, "logo-name"], ["src", "/assets/img/brand/logo.png", 1, "logo-img"], [1, "appversion"], [1, "card-group"], [1, "card", "p-4", "boxlogin"], [1, "card-body"], [3, "formGroup", "ngSubmit"], [1, "input-group", "mb-3"], [1, "input-group-prepend"], [1, "input-group-text"], [1, "fas", "fa-user"], ["type", "text", "formControlName", "username", "placeholder", "Username", "autocomplete", "username", 1, "form-control", 3, "ngClass"], ["class", "invalid-feedback", 4, "ngIf"], [1, "input-group", "mb-4"], [1, "fas", "fa-key"], ["type", "password", "formControlName", "password", "placeholder", "Password", "autocomplete", "current-password", "required", "", 1, "form-control", 3, "ngClass"], [1, "col-12"], [1, "form-group", "text-right"], [1, "btn", "btn-primary", "loginbtn", 3, "disabled"], ["class", "spinner-border spinner-border-sm mr-1", 4, "ngIf"], [1, "row", 2, "position", "relative"], [3, "alertmessage", 4, "ngIf"], [1, "invalid-feedback"], [4, "ngIf"], [1, "spinner-border", "spinner-border-sm", "mr-1"], [3, "alertmessage"]], template: function BaseLoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "main", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "h3", 5);
        ɵɵtext(6, "Welcome to");
        ɵɵelementEnd();
        ɵɵelementStart(7, "h1", 6);
        ɵɵelement(8, "img", 7);
        ɵɵtext(9, " GeoAI");
        ɵɵelementEnd();
        ɵɵelementStart(10, "div", 8);
        ɵɵtext(11);
        ɵɵelementEnd();
        ɵɵelementStart(12, "div", 9);
        ɵɵelementStart(13, "div", 10);
        ɵɵelementStart(14, "div", 11);
        ɵɵelementStart(15, "form", 12);
        ɵɵlistener("ngSubmit", function BaseLoginComponent_Template_form_ngSubmit_15_listener() { return ctx.onSubmit(); });
        ɵɵelementStart(16, "h2");
        ɵɵtext(17, "Sign In");
        ɵɵelementEnd();
        ɵɵelementStart(18, "p");
        ɵɵtext(19, "Enter your credentials");
        ɵɵelementEnd();
        ɵɵelementStart(20, "div", 13);
        ɵɵelementStart(21, "div", 14);
        ɵɵelementStart(22, "span", 15);
        ɵɵelement(23, "i", 16);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(24, "input", 17);
        ɵɵtemplate(25, BaseLoginComponent_div_25_Template, 2, 1, "div", 18);
        ɵɵelementEnd();
        ɵɵelementStart(26, "div", 19);
        ɵɵelementStart(27, "div", 14);
        ɵɵelementStart(28, "span", 15);
        ɵɵelement(29, "i", 20);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(30, "input", 21);
        ɵɵelementEnd();
        ɵɵelementStart(31, "div", 3);
        ɵɵelementStart(32, "div", 22);
        ɵɵelementStart(33, "div", 23);
        ɵɵelementStart(34, "button", 24);
        ɵɵtemplate(35, BaseLoginComponent_span_35_Template, 1, 0, "span", 25);
        ɵɵtext(36, " Login ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(37, "div", 26);
        ɵɵtemplate(38, BaseLoginComponent_app_frms_messagebar_38_Template, 1, 1, "app-frms-messagebar", 27);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(11);
        ɵɵtextInterpolate1("V", ctx.appversion, "");
        ɵɵadvance(4);
        ɵɵproperty("formGroup", ctx.loginForm);
        ɵɵadvance(9);
        ɵɵproperty("ngClass", ɵɵpureFunction1(8, _c0$5, ctx.submitted && ctx.f.username.errors));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.submitted && ctx.f.username.errors);
        ɵɵadvance(5);
        ɵɵproperty("ngClass", ɵɵpureFunction1(10, _c0$5, ctx.submitted && ctx.f.password.errors));
        ɵɵadvance(4);
        ɵɵproperty("disabled", ctx.loadinglist);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.loadinglist);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.alertmessage);
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgClass, NgIf, RequiredValidator, MessagebarComponent], styles: ["body[_ngcontent-%COMP%]{background-color:#fff}.welcome[_ngcontent-%COMP%]{color:#000;margin-bottom:0;position:relative}.appversion[_ngcontent-%COMP%]{font-size:.7rem;margin-top:0;padding-right:5px;text-align:right}.logo-name[_ngcontent-%COMP%]{color:#335aca;font-size:8rem;font-weight:800;letter-spacing:-.6rem;line-height:8rem;margin-bottom:0}.logo-img[_ngcontent-%COMP%]{position:relative;top:-10px;width:77px}.loginbtn[_ngcontent-%COMP%]{padding-left:3rem;padding-right:3rem}.portada[_ngcontent-%COMP%]{background-size:cover;height:100%;position:absolute;width:100%}.portada-filter[_ngcontent-%COMP%]{background:linear-gradient(0deg,hsla(0,0%,100%,.2) 5%,hsla(0,0%,100%,.9));height:100%;position:relative}.mainbox[_ngcontent-%COMP%]{background-color:#fff;height:100%;left:0;position:absolute;top:0;width:100%}.boxlogin[_ngcontent-%COMP%]{background-color:#7aaf47;border:1px solid #9895bd;box-shadow:0 4px 40px 0 rgba(0,0,0,.14),0 7px 60px -5px rgba(0,0,0,.4);color:#fff}.boxlogin[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#000;font-size:1.5rem}.boxlogin[_ngcontent-%COMP%]   .invalid-feedback[_ngcontent-%COMP%]{font-size:1rem}.form-control[_ngcontent-%COMP%]{background-color:#fff}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BaseLoginComponent, [{
        type: Component,
        args: [{
                selector: 'app-dashboard',
                templateUrl: 'baselogin.component.html',
                styleUrls: ['./baselogin.component.scss'],
                providers: [Md5]
            }]
    }], function () { return [{ type: FormBuilder }, { type: ActivatedRoute }, { type: Router }, { type: AuthenticationServiceAbs, decorators: [{
                type: Inject,
                args: [AUTH_SERVICE_PROVIDER_TOKEN]
            }] }]; }, null); })();

/**
 * Notifier module
 */
class AuthModule {
}
AuthModule.ɵmod = ɵɵdefineNgModule({ type: AuthModule });
AuthModule.ɵinj = ɵɵdefineInjector({ factory: function AuthModule_Factory(t) { return new (t || AuthModule)(); }, providers: [], imports: [[
            CommonModule,
            MaterialModule,
            FormsModule,
            ReactiveFormsModule,
            MessagebarModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AuthModule, { declarations: [BaseLoginComponent], imports: [CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MessagebarModule], exports: [BaseLoginComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MaterialModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MessagebarModule
                ],
                declarations: [
                    BaseLoginComponent
                ],
                exports: [
                    BaseLoginComponent
                ],
                providers: []
            }]
    }], null, null); })();

class BaseComponentsModule {
}
BaseComponentsModule.ɵmod = ɵɵdefineNgModule({ type: BaseComponentsModule });
BaseComponentsModule.ɵinj = ɵɵdefineInjector({ factory: function BaseComponentsModule_Factory(t) { return new (t || BaseComponentsModule)(); }, providers: [
        ErrorcontrolService
    ], imports: [[
            CommonModule,
            MaterialModule,
            FormsModule,
            ReactiveFormsModule,
            NotifierModule,
            BaseUICommonModule,
            AlertModule,
            MessagebarModule,
            DialogsModule,
            ErrorPagesModule,
            AuthModule
        ], AlertModule,
        NotifierModule,
        DialogsModule,
        MessagebarModule,
        ErrorPagesModule,
        AuthModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(BaseComponentsModule, { declarations: [BaseModelComponent,
        AppCheckBoxComponent,
        AppCheckBoxIconComponent,
        FlagIconComponent,
        CtxMenuComponent,
        FrmFieldobjComponent,
        FilterlistComponent,
        SearchBoxComponent,
        SelectCheckAllComponent,
        NavIconToggleComponent], imports: [CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        NotifierModule,
        BaseUICommonModule,
        AlertModule,
        MessagebarModule,
        DialogsModule,
        ErrorPagesModule,
        AuthModule], exports: [AlertModule,
        NotifierModule,
        DialogsModule,
        BaseModelComponent,
        AppCheckBoxComponent,
        AppCheckBoxIconComponent,
        FlagIconComponent,
        CtxMenuComponent,
        MessagebarModule,
        FilterlistComponent,
        SearchBoxComponent,
        SelectCheckAllComponent,
        ErrorPagesModule,
        NavIconToggleComponent,
        AuthModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(BaseComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MaterialModule,
                    FormsModule,
                    ReactiveFormsModule,
                    NotifierModule,
                    BaseUICommonModule,
                    AlertModule,
                    MessagebarModule,
                    DialogsModule,
                    ErrorPagesModule,
                    AuthModule
                ],
                declarations: [
                    BaseModelComponent,
                    AppCheckBoxComponent,
                    AppCheckBoxIconComponent,
                    FlagIconComponent,
                    CtxMenuComponent,
                    FrmFieldobjComponent,
                    FilterlistComponent,
                    SearchBoxComponent,
                    SelectCheckAllComponent,
                    NavIconToggleComponent
                ],
                entryComponents: [],
                exports: [
                    AlertModule,
                    NotifierModule,
                    DialogsModule,
                    BaseModelComponent,
                    AppCheckBoxComponent,
                    AppCheckBoxIconComponent,
                    FlagIconComponent,
                    CtxMenuComponent,
                    MessagebarModule,
                    FilterlistComponent,
                    SearchBoxComponent,
                    SelectCheckAllComponent,
                    ErrorPagesModule,
                    NavIconToggleComponent,
                    AuthModule
                ],
                providers: [
                    ErrorcontrolService
                ]
            }]
    }], null, null); })();

let COUNTRY_PICKER_CONFIG = new InjectionToken('countrypicker.config');
const COUNTRY_PICKER_CONFIG_DEFAULT = {
    baseUrl: "assets/"
};

class CountryPickerService {
    /*   constructor(private config: CountryPickerConfig, private http: Http) {
        this.baseUrl = config.baseUrl;
        this.data = this.loadData();
      } */
    constructor(config, http) {
        this.http = http;
        this.dataUrl = 'countries.json';
        this.data = null;
        //private data: BehaviorSubject<ICountry[]> = new BehaviorSubject([]);
        this.baseUrl = 'assets/';
        console.log("CountryPickerService start");
        this.baseUrl = config.baseUrl;
        let isCached = this.getFromStore();
        if (isCached) {
            return;
        }
        this.data = this.loadData().pipe(tap(res => this.storeLocal(res)), map(res => CountryPickerService.sortCountries(res, "name.common")));
    }
    storeLocal(countries) {
        console.log("Countries received. Store to local");
        localStorage.setItem('geo-countries', JSON.stringify(countries));
    }
    getFromStore() {
        let c = localStorage.getItem('geo-countries');
        if (c) {
            this.data = of(JSON.parse(c));
            console.log("Countries from local cache");
            return true;
        }
        return false;
    }
    loadData() {
        return this.http.get(this.baseUrl + this.dataUrl)
            .pipe(
        //tap(res=>this.data.next(res))
        map((res) => {
            //console.log ("resmap=",res);
            return res || {};
        }), catchError(this.handleError));
    }
    handleError(error) {
        let errMsg;
        console.log("Error:", error);
        if (error instanceof Response) {
            if (error.status === 404) {
                errMsg = 'Error loading countries.json file. Please configure WebPack and load countries.json assets to your root folder';
            }
            const body = error.json() || '';
            const err = body.toString || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
    getCountries() {
        //let c=this.data.pipe
        return this.data.pipe(map(countries => countries.map(country => {
            country.name.native[0] = country.name.native[Object.keys(country.name.native)[0]];
            return country;
        })));
    }
    static sortCountries(countries, byField) {
        countries = countries.sort((a, b) => {
            let na = get(a, byField);
            let nb = get(b, byField);
            if (na > nb) {
                return 1;
            }
            if (na < nb) {
                return -1;
            }
            return 0;
        });
        return countries;
    }
    static uigetCountry(countries, countryNamecca3) {
        if (!countries) {
            return;
        }
        if (!countryNamecca3) {
            return "";
        }
        const country = countries.find(c => c.cca3 === countryNamecca3);
        if (country) {
            return country.name.common;
        }
        else {
            return "";
        }
    }
    static uigetCountryObj(countries, countryNamecca3) {
        //console.log(this.countries);
        if (!countries) {
            return null;
        }
        if (!countryNamecca3) {
            return null;
        }
        const country = countries.find(c => c.cca3 === countryNamecca3);
        if (country) {
            return country;
        }
        else {
            return null;
        }
    }
}
CountryPickerService.ɵfac = function CountryPickerService_Factory(t) { return new (t || CountryPickerService)(ɵɵinject(COUNTRY_PICKER_CONFIG), ɵɵinject(HttpClient)); };
CountryPickerService.ɵprov = ɵɵdefineInjectable({ token: CountryPickerService, factory: CountryPickerService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CountryPickerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [COUNTRY_PICKER_CONFIG]
            }] }, { type: HttpClient }]; }, null); })();

function CountryPickerComponent_option_2_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 4);
} if (rf & 2) {
    const c_r1 = ɵɵnextContext().$implicit;
    const ctx_r3 = ɵɵnextContext();
    ɵɵpropertyInterpolate1("src", "", ctx_r3.baseUrl + c_r1.cca3, ".svg", ɵɵsanitizeUrl);
    ɵɵproperty("hidden", !ctx_r3.flag);
} }
function CountryPickerComponent_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "option", 2);
    ɵɵtemplate(1, CountryPickerComponent_option_2_img_1_Template, 1, 2, "img", 3);
    ɵɵtext(2);
    ɵɵelementEnd();
} if (rf & 2) {
    const c_r1 = ctx.$implicit;
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("value", ctx_r0.getValue(c_r1));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.flag);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r0.getName(c_r1));
} }
class CountryPickerComponent {
    constructor(countryPickerService) {
        this.countryPickerService = countryPickerService;
        this.controlname = 'countryselect';
        this.flag = false;
        this.setValue = 'cca3';
        this.setName = 'name.common';
        this.baseUrl = '';
        this.countryPickerService.getCountries().subscribe(countries => {
            this.countries = countries.sort((a, b) => {
                let na = this.getName(a);
                let nb = this.getName(b);
                if (na > nb) {
                    return 1;
                }
                if (na < nb) {
                    return -1;
                }
                return 0;
            });
        });
        this.baseUrl = countryPickerService.baseUrl + "countrydata/";
    }
    get isValid() { return this.form.controls[this.controlname].valid; }
    getValue(obj) {
        return get(obj, this.setValue);
    }
    getName(obj) {
        return get(obj, this.setName);
    }
}
CountryPickerComponent.ɵfac = function CountryPickerComponent_Factory(t) { return new (t || CountryPickerComponent)(ɵɵdirectiveInject(CountryPickerService)); };
CountryPickerComponent.ɵcmp = ɵɵdefineComponent({ type: CountryPickerComponent, selectors: [["app-countrypicker"]], inputs: { controlname: "controlname", form: "form", flag: "flag", setValue: "setValue", setName: "setName" }, decls: 3, vars: 1, consts: [[1, "form-control", "form-control-sm"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [3, "hidden", "src", 4, "ngIf"], [3, "hidden", "src"]], template: function CountryPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div");
        ɵɵelementStart(1, "select", 0);
        ɵɵtemplate(2, CountryPickerComponent_option_2_Template, 3, 3, "option", 1);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.countries);
    } }, directives: [NgForOf, NgSelectOption, ɵangular_packages_forms_forms_x, NgIf], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CountryPickerComponent, [{
        type: Component,
        args: [{
                selector: 'app-countrypicker',
                template: `<div > <select class="form-control form-control-sm" >
                <option *ngFor="let c of countries; let i = index;" [value]="getValue(c)"><img *ngIf="flag" [hidden]="!flag" src="{{baseUrl + c.cca3}}.svg">{{getName(c)}}</option>
            </select></div>`
            }]
    }], function () { return [{ type: CountryPickerService }]; }, { controlname: [{
            type: Input
        }], form: [{
            type: Input
        }], flag: [{
            type: Input
        }], setValue: [{
            type: Input
        }], setName: [{
            type: Input
        }] }); })();

function countryPickerServiceFactory(config, http) {
    return new CountryPickerService(config, http);
}
class CountryPickerModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('CountryPickerModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot(providedConfig = COUNTRY_PICKER_CONFIG_DEFAULT) {
        return {
            ngModule: CountryPickerModule,
            providers: [{
                    provide: COUNTRY_PICKER_CONFIG,
                    useValue: providedConfig
                },
                {
                    provide: CountryPickerService,
                    useFactory: countryPickerServiceFactory,
                    deps: [COUNTRY_PICKER_CONFIG, HttpClient]
                }]
        };
    }
}
CountryPickerModule.ɵmod = ɵɵdefineNgModule({ type: CountryPickerModule });
CountryPickerModule.ɵinj = ɵɵdefineInjector({ factory: function CountryPickerModule_Factory(t) { return new (t || CountryPickerModule)(ɵɵinject(CountryPickerModule, 12)); }, imports: [[
            CommonModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(CountryPickerModule, { declarations: [CountryPickerComponent], imports: [CommonModule,
        ReactiveFormsModule], exports: [CountryPickerComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(CountryPickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule
                ],
                declarations: [
                    CountryPickerComponent
                ],
                entryComponents: [],
                exports: [
                    CountryPickerComponent
                ]
            }]
    }], function () { return [{ type: CountryPickerModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

function FrmsToolTipComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵtext(0);
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
} }
function FrmsToolTipComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
/**
 * This component will be used to show custom tooltip
 *
 * This component will be rendered using OverlayModule of angular material
 * This component will be rendered by directive on an Overlay
 *
 * CONSUMER will not be using this component directly
 * This component will be hosted in an overlay by ToolTipRenderer directive
 * This component exposes two properties. These two properties will be filled by ToolTipRenderer directive
 * 1. text - This is a simple string which is to be shown in the tooltip; This will be injected in the ToolTipRenderer directive
 *    by the consumer
 * 2. contentTemplate - This gives finer control on the content to be shwon in the tooltip
 *
 * NOTE - ONLY one should be specified; If BOTH are specified then "template" will be rendered and "text" will be ignored
 */
class FrmsToolTipComponent {
    constructor() { }
    ngOnInit() {
    }
}
FrmsToolTipComponent.ɵfac = function FrmsToolTipComponent_Factory(t) { return new (t || FrmsToolTipComponent)(); };
FrmsToolTipComponent.ɵcmp = ɵɵdefineComponent({ type: FrmsToolTipComponent, selectors: [["frms-tooltip"]], inputs: { text: "text", contentTemplate: "contentTemplate" }, decls: 5, vars: 1, consts: [[1, "tooltip-conatiner"], ["simpleText", ""], [4, "ngTemplateOutlet"]], template: function FrmsToolTipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div");
        ɵɵelementStart(1, "div", 0);
        ɵɵtemplate(2, FrmsToolTipComponent_ng_template_2_Template, 1, 1, "ng-template", null, 1, ɵɵtemplateRefExtractor);
        ɵɵtemplate(4, FrmsToolTipComponent_ng_container_4_Template, 1, 0, "ng-container", 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(3);
        ɵɵadvance(4);
        ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate || _r0);
    } }, styles: [".tooltip-conatiner[_ngcontent-%COMP%]{background:linear-gradient(#fff,#e4e5f0);border:1px solid grey;border-radius:2px;padding:1px 5px 4px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FrmsToolTipComponent, [{
        type: Component,
        args: [{
                selector: 'frms-tooltip',
                templateUrl: './frms-tooltip.component.html',
                styleUrls: ['./frms-tooltip.component.scss']
            }]
    }], function () { return []; }, { text: [{
            type: Input
        }], contentTemplate: [{
            type: Input
        }] }); })();

/*
 * Public API Surface of basecomponents
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertModule, AlertService, AppCheckBoxComponent, AppCheckBoxIconComponent, AuthModule, BaseComponentsModule, BaseLoginComponent, BaseModelComponent, COUNTRY_PICKER_CONFIG, COUNTRY_PICKER_CONFIG_DEFAULT, CountryPickerComponent, CountryPickerModule, CountryPickerService, CtxMenuComponent, DialogHeader1Component, DialogLessHeaderComponent, DialogQuestionComponent, DialogdeleteComponent, DialoginfoComponent, DialogsModule, ErrorPagesModule, ErrorcontrolService, FilterlistComponent, FlagIconComponent, FrmFieldobjComponent, FrmsToolTipComponent, MessagebarComponent, MessagebarModule, NavIconToggleComponent, NotifierContainerComponent, NotifierModule, NotifierService, P403Component, P404Component, P500Component, SearchBoxComponent, SelectCheckAllComponent, countryPickerServiceFactory, notifierCustomConfigFactory, notifierDefaultConfigFactory };
//# sourceMappingURL=basecomponents.js.map
